import * as util from 'util';
import _ from 'lodash';
import {RouteService} from "../../../../services/routeService";
import {NotificationService} from "../../../../services/notificationService";
import {GeneralService} from "../../../../services/generalService";
import {DICTIONARY} from "../../../../dictionary";
import {Component, OnInit, ViewChild} from "@angular/core";
import {Router} from "@angular/router";
import {eachLimit} from 'async';
import {LookAndFeelService} from "../../../../services/lookAndFeelService";
import {TrustifiTableComponent} from "../../../uiComponents/trustifi-table/trustifi-table.component";

@Component({
	selector: 'user-management-component',
	templateUrl: './user-management.component.html',
})
export class UserManagementComponent implements OnInit {

	@ViewChild('usersTableEl') usersTableEl: TrustifiTableComponent;

    constructor(private router:Router,
				public gs:GeneralService,
				public lfs:LookAndFeelService,
				private rs:RouteService,
				private ns:NotificationService,) {
    }

    Math = Math;
    dic = DICTIONARY;
	_ = _;
    stopActiveUserPopup = false;
    usersListView = this.dic.CONSTANTS.userMgmntListViews.all;
    orderBy = 'role_priority';
    sharedPlanInfo:any = { users:[], relay:{} };
    selectExpirationTextFlag = false;
    contactAutocompleteData = {
        showContacts:  false,
        emailInput: ''
    };
    isCompanyView = false;
    expandMethods = {
        oneMonth: {display: 'one month', value: 'month'},
        oneYear: {display: 'one year', value: 'year'},
        twoYears: {display: '2 years', value: '2years'},
        threeYears: {display: '3 years', value: '3years'},
    };
    summernoteOptions = {
        height: 210,
        maxHeight: 210,
        width: 555,
        disableResizeEditor: true,
        popover: false,
        toolbar: [
            ['style', ['bold', 'italic', 'underline', 'clear']],
            ['color', ['color']],
            ['view', ['codeview']]
        ],
        codemirror: {
            theme: 'monokai'
        },
        placeholder: 'Your invitation to plan message'
    };

    isLoaded;
	addNewUserInputTxt;
	doNotChangeIsExpandedStates;
    users;
    userInfo;
    userRole;
    isPartnerAdmin;
    userManagementLoaded;
    usersList;
    loadingUsersInProcess;
    isPartnerAllowedChangeClients;
    isUserDomaimVerified;
    isAnyDomaimVerified;
    accountPasswordExpiration;
    mainAdminUser;
    companyNamesExisting;
    rolesExisting;
    mainPlanAdmin;
    adminExpirationDateMinString;
    filterData;
    UserSharedPlanStatistics;
    showGroups;
    showAliases; // CC: taken from inbound-mailboxes.component.ts
    SharedPlanStatistics;
    addActiveUserPopup;
    template;
    changeUserSettingsPopup;
	setUserTimezonePopup;
	userPermissionPopup;
	userMfaPopup;
    moveUserToAdminPopup;
    moveUserToAdminInProcess;
    allContacts;
    modalData;
    listAdded;
	loginCountriesMethods = {
		all: 'all',
		allowlist: 'allowlist',
		blocklist: 'blocklist'
	};
	accountConfigPopup;
	suppressionPopup;
    adminExpirationDateMaxString;
	timeZones = this.gs.getAllTimeZones();
	newPlanWizard = null;
	planPolicies;
	curSharedUser;

	ngOnInit() {
        this.isLoaded = false;
        this.isCompanyView = false;
        this.users = [];

        this.sharedPlanInfo = { users:[], relay:{} };

        this.gs.getUserInfo(false, (userInfo) => {
            this.userInfo = userInfo;
            this.userRole = userInfo.user_role;
            this.isPartnerAdmin = this.gs.isPartnerAdmin(this.userInfo);
			if (this.isPartnerAdmin) {
				this.rs.getInstallPolicies().then((response) => {
					this.planPolicies = response || [];
				});
			}

            this.getUsersOfSharedPlan();

            this.userManagementLoaded = true;
        });
    };

    getUsersOfSharedPlan = () => {
        this.usersList = [];
        this.loadingUsersInProcess = true;

        this.rs.getUsersOfSharedPlan({}).then((response) => {
            this.sharedPlanInfo = response;
            this.isPartnerAllowedChangeClients = response.partners && response.partners.modify_client_plans

            const userDomain = this.gs.getDomain(this.userInfo.email);
            this.isUserDomaimVerified = response.domains && response.domains.length &&
                response.domains.find(d => d.domain === userDomain && d.verified) || false;
            this.isAnyDomaimVerified = response.domains && response.domains.length &&
                response.domains.some(d => d.verified) || false;
            this.accountPasswordExpiration = response.account_password_expiration || {
                enabled: false,
                expiration_days: 90
            };

			if (this.gs.isPartnerAdmin(this.userInfo)) {
				this.sharedPlanInfo.users[0].customer_user_role = this.sharedPlanInfo.customer_id+" Admin";
			}
			else {
				this.sharedPlanInfo.users[0].customer_user_role = "Admin";
			}
			this.mainAdminUser = this.sharedPlanInfo.users[0];

            this.companyNamesExisting = [];
            this.rolesExisting = ['User'];
            if (this.userInfo.plan.customer_id) {
                this.rolesExisting.push('Plan Admin', 'Managed Plan', 'Template Plan', 'Global Reviewer');
            }
            else {
                this.rolesExisting.push('Admin');
            }

            this.sharedPlanInfo.users.forEach(user => {
                user.user_role = user.user_role || user.customer_user_role;
				if (_.isUndefined(user.is_relay)) {
					user.is_relay = false;
				}
                if (user.user_role === this.dic.CONSTANTS.userRole.subAdmin) {
                    user.customer_user_role = this.sharedPlanInfo.users[0].customer_user_role;
                }

				this.getUserStatusTooltip(user);

				user.isSelectable = true;

				this.setEmailAndRoleDisplay(user, this.sharedPlanInfo.users[0])
            });
            this.updateListView(this.usersListView);
            this.mainPlanAdmin = this.sharedPlanInfo.users[0];
            this.adminExpirationDateMinString = this.formatDateString(new Date());
            this.adminExpirationDateMaxString = this.formatDateString(new Date(this.mainPlanAdmin.alloc_plan_id.expired));

            this.initFilters();

			this.setPartnersPageFilter();
            this.createCompanyGroups();
            this.isLoaded = true;
            this.loadingUsersInProcess = false;
        }, err => {
            this.loadingUsersInProcess = false;
            this.isLoaded = true;
        });
    };

	setEmailAndRoleDisplay = (user, parentUser) => {
		this.setEmailDisplay(user);
		this.setRolePriority(user, parentUser);

		if (user.planUsers?.length) {
			user.planUsers.forEach(subUser => {
				this.getUserStatusTooltip(subUser);
				this.setEmailAndRoleDisplay(subUser,user);
			});
		}
	}

    setEmailDisplay = (user) => {
        user.email_display = user.email;
        const emailParts = user.email.split('@');
        if (user.alloc_plan_id?.is_managed || this.isTemplatePlan(user)) {
            if (emailParts[1] === 'trustifi.com') {
                user.email_display = emailParts[0];
            }
            else {
                user.email_display = emailParts[1];
            }
        }
    }

    createCompanyGroups = () => {
		const companiesList = [];
		const companyGroups = _.groupBy(this.sharedPlanInfo.users, 'company_name_display');

        _.each(companyGroups, (companyUsers, companyName) => {
            const companyAdmin = companyUsers.find(itm => itm.user_role === this.dic.CONSTANTS.userRole.admin);
			companiesList.push({
				companyName,
				isCompanyTitleRecord: true,
				isSelectable: false,
				hideActions: true,
                expired: companyAdmin && companyAdmin.alloc_plan_id && companyAdmin.alloc_plan_id.expired,
                planUsers: companyUsers
            });
        });

		return companiesList;
    };

	showMultipleUsersActions = () => {
		return  _.compact([
			{
				display: 'Managed plan',
				submenu:[
					this.dic.CONSTANTS.userActions.enableManagedPlan,
					this.dic.CONSTANTS.userActions.disableManagedPlan
				]
			},
			{
				display: 'Block/Unblock users',
				submenu:[
					this.dic.CONSTANTS.userActions.blockUsers,
					this.dic.CONSTANTS.userActions.unblockUsers
				]
			},
			this.dic.CONSTANTS.userActions.loginMfa,
			this.dic.CONSTANTS.userActions.sendWelcomeEmail,
			this.dic.CONSTANTS.userActions.setTimezone,
			this.dic.CONSTANTS.userActions.suppressionList,
			this.dic.CONSTANTS.userActions.remove
		]);
	}

	selectMultipleUsersAction = (selectedItems, action) => {
		switch(action) {
			case this.dic.CONSTANTS.userActions.remove:
				this.removeUserFromSharedPlan(selectedItems);
				break;

			case this.dic.CONSTANTS.userActions.setTimezone:
				this.openSetUserTimezonePopup(selectedItems);
				break;

			case this.dic.CONSTANTS.userActions.loginMfa:
				this.toggleMFAForPlanUsers(selectedItems);
				break;

			case this.dic.CONSTANTS.userActions.suppressionList:
				this.checkUserOnSuppressionList(selectedItems);
				break;

			case this.dic.CONSTANTS.userActions.disableManagedPlan:
				this.changeManagedPlan(selectedItems, false);
				break;

			case this.dic.CONSTANTS.userActions.blockUsers:
			case this.dic.CONSTANTS.userActions.unblockUsers:
				this.changeUsersStatus(selectedItems, action === this.dic.CONSTANTS.userActions.blockUsers);
				break;

			case this.dic.CONSTANTS.userActions.sendWelcomeEmail:
				this.sendWelcomeEmail(selectedItems);
				break;
		}
	}


    showUserActions = (userObj) => {
		if (this.isTemplatePlan(userObj)) {
			return [this.dic.CONSTANTS.userActions.removePlan];
		}

		// sub row. user inside other's plan
		if (userObj.depth && !this.isPartnerAllowedChangeClients) {
			return [this.dic.CONSTANTS.userActions.moveToOtherAdmin];
		}

		// main admin
		if (userObj.customer_user_role && userObj.user_role === this.dic.CONSTANTS.userRole.admin) {
			return [
				this.dic.CONSTANTS.userActions.updateUserSettings,
			];
		}

		// invited user
		if (userObj.status === this.dic.CONSTANTS.userInPlanStatus.invitationSent) {
			return [
				this.dic.CONSTANTS.userActions.resendInvitation,
				this.dic.CONSTANTS.userActions.remove
			];
		}

		// admin
		if (userObj.user_role === this.dic.CONSTANTS.userRole.admin) {
			return [
				(userObj.status === this.dic.CONSTANTS.userInPlanStatus.blocked ||
					userObj.status === this.dic.CONSTANTS.userInPlanStatus.planBlocked ||
					userObj.status === this.dic.CONSTANTS.userInPlanStatus.blockUser24hours ||
					userObj.status === this.dic.CONSTANTS.userInPlanStatus.riskyUser24hours) ?
					this.dic.CONSTANTS.userActions.unblock : this.dic.CONSTANTS.userActions.block,
				userObj.alloc_plan_id.is_managed ? this.dic.CONSTANTS.userActions.disableManagedPlan : this.dic.CONSTANTS.userActions.enableManagedPlan,
				this.dic.CONSTANTS.userActions.sendWelcomeEmail,
				this.dic.CONSTANTS.userActions.modifyResources,
				this.dic.CONSTANTS.userActions.updateUserSettings,
				this.dic.CONSTANTS.userActions.suppressionList,
				this.dic.CONSTANTS.userActions.removePlan
			];
		}

		// sub admin
		if (userObj.user_role === this.dic.CONSTANTS.userRole.subAdmin) {
			return [
				this.dic.CONSTANTS.userActions.modifyUserPermissions,
				(userObj.status === this.dic.CONSTANTS.userInPlanStatus.blocked ||
					userObj.status === this.dic.CONSTANTS.userInPlanStatus.planBlocked ||
					userObj.status === this.dic.CONSTANTS.userInPlanStatus.blockUser24hours ||
					userObj.status === this.dic.CONSTANTS.userInPlanStatus.riskyUser24hours) ?
					this.dic.CONSTANTS.userActions.unblock : this.dic.CONSTANTS.userActions.block,
				this.dic.CONSTANTS.userActions.remove,
				this.dic.CONSTANTS.userActions.updateUserSettings,
				this.dic.CONSTANTS.userActions.suppressionList,
				this.dic.CONSTANTS.userActions.sendWelcomeEmail
			];
		}

		// user
		if (userObj.user_role === this.dic.CONSTANTS.userRole.user) {
			const actions = [
				this.dic.CONSTANTS.userActions.modifyUserPermissions,
				(userObj.status === this.dic.CONSTANTS.userInPlanStatus.blocked ||
					userObj.status === this.dic.CONSTANTS.userInPlanStatus.planBlocked ||
					userObj.status === this.dic.CONSTANTS.userInPlanStatus.blockUser24hours ||
					userObj.status === this.dic.CONSTANTS.userInPlanStatus.riskyUser24hours) ?
					this.dic.CONSTANTS.userActions.unblock : this.dic.CONSTANTS.userActions.block,
				this.dic.CONSTANTS.userActions.remove,
				this.dic.CONSTANTS.userActions.updateUserSettings,
				this.dic.CONSTANTS.userActions.suppressionList,
				this.dic.CONSTANTS.userActions.sendWelcomeEmail
			];

			if (this.isPartnerAdmin) {
				actions.push(
					this.dic.CONSTANTS.userActions.moveToOtherAdmin,
					this.dic.CONSTANTS.userActions.allocatePlan);
			}
			return actions;
		}
    };

    togglePlanUsers = (shared, enforcedValue) => {
        shared.planShowUsers = enforcedValue || !shared.planShowUsers;
    };

	toggleExpandItem = (item, event) => {
		if (!item.planUsers?.length) {
			return;
		}

		item.isExpanded = !item.isExpanded;
		event.stopPropagation();
		this.doNotChangeIsExpandedStates = true;

		// refresh the trustifi-table by changing the list. The directive detects changes and fires an update
		this.usersList = _.cloneDeep(this.usersList);
	}

    getUserOfSharedPlanStatistics = (curSharedUser) => {
        this.UserSharedPlanStatistics = [];

        const actionInfo = {
            action: this.dic.CONSTANTS.planUsersActions.statistics,
            depth: curSharedUser.depth,
            parent: curSharedUser.parent
        }
        this.rs.doActionOnPlanUser(curSharedUser.email, actionInfo).then( (response) => {
            this.UserSharedPlanStatistics = response;
        });
    };

	searchUser = (searchTerm, activeFilters) => {
		this.usersList.forEach(record => {
			if (!searchTerm && !activeFilters) {
				showAllSubUsers(record);
			}

			// search + filter

			const isFound = this.searchUserExecute(record, searchTerm, activeFilters);
			if (!isFound) {
				record.hide = true;
				return;
			}

			record.displayedCounter = record.planUsers?.length && _.reject(record.planUsers, 'hide').length;

			record.hide = false;
        });

		this.doNotChangeIsExpandedStates = false;
    };

    getSharedPlanStatistics = (sharedUser) => {
        this.SharedPlanStatistics = [];

        const actionInfo = {
            action: this.dic.CONSTANTS.planAdminActions.statistics,
            depth: sharedUser.depth,
            parent: sharedUser.parent
        }
        this.rs.doActionOnPlanAdmin(sharedUser.email, actionInfo).then((response) => {
            this.SharedPlanStatistics = response;
        });
    };

    parseListsContactsBeforeSend =() => {
        let contacts = this.users
            .filter(u => u.email !== 'List')
            .map(c => ({name: c.name, email: c.email}));

        this.users
            .filter(u => u.email === 'List')
            .forEach(u => {
                contacts = contacts.concat(u.originalList.contacts.map(c => ({name: c.name, email: c.email})));
            });

        return contacts;
    };

    addUsersToSharedPlanExecute = () => {
        // parse list types to contacts
        const contacts = this.parseListsContactsBeforeSend();
        this.rs.inviteUserToSharedPlan({
            emails: contacts,
			admin_permissions: {enabled: this.addActiveUserPopup.adminPermissions}
        }).then(() => {
            this.stopActiveUserPopup = false;
            this.users = [];
            this.closePopupAndRemoveAllTags();

            contacts.forEach((contact) => {
                const newUser = {
                    name: contact.name, email: contact.email, user_role: this.addActiveUserPopup.adminPermissions ? this.dic.CONSTANTS.userRole.subAdmin : this.dic.CONSTANTS.userRole.user,
                    status: this.dic.CONSTANTS.userInPlanStatus.invitationSent, is_relay: false
                };
				this.setEmailAndRoleDisplay(newUser, this.mainPlanAdmin);
				this.sharedPlanInfo.users.push(newUser);
                this.updateListView(this.usersListView);
            });
            this.mainPlanAdmin.alloc_plan_id.shared_plan.used_users += contacts.length;
            this.ns.showInfoMessage(this.dic.MESSAGES.userMgmtInvite);
        }, (err) => {
            this.stopActiveUserPopup = false;
            if (err.data && err.data.message) {
                this.ns.showErrorMessage(err.data.message);
            }
        });
    };

    closePopupAndRemoveAllTags = () => {
        this.addActiveUserPopup.show = false;

        let userTags:any = document.getElementById('users-to-invite');
        if (!userTags) return;
        while (userTags.children.length > 1) {
            userTags.removeChild(userTags.firstChild);
        }
    };

    updateTemplateAndAddUsersToSharedPlan = () => {
        if (!this.template || !this.template.html || !this.template.html.length) {
            this.ns.showWarnMessage(this.dic.ERRORS.userMgmtInviteNoMessage);
            return;
        }

		if (this.addNewUserInputTxt) {
			this.confirmNewUserEmail(this.addNewUserInputTxt);
		}

        if (this.users.length == 0) {
			this.ns.showWarnMessage(util.format(this.dic.ERRORS.xAtLeastOneX, 'add', 'user'));
			return;
        }

        this.stopActiveUserPopup = true;

        if (this.template.html !== this.template.originalHtml) {
            this.rs.updateTemplate(this.template._id, this.template).then((response) => {
                let summernote:any = this.gs.getSummernote();
                if (summernote && summernote.summernote('codeview.isActivated')) {
                    summernote.summernote('codeview.deactivate');
                }
                this.addUsersToSharedPlanExecute();
            });
        }
        else {
            this.addUsersToSharedPlanExecute();
        }
    };

    addAdminToSharedPlan = () => {
        const curSharedUser = this.newPlanWizard.curSharedUser;
        const copyPolicyData = this.newPlanWizard.copyPolicyData;

        if (curSharedUser.planManagedBy?.display === 'Template') {
            this.addPlanTemplate();
            return;
        }

        if (!curSharedUser.adminExpirationDate) {
            this.ns.showWarnMessage(this.dic.ERRORS.sharedPlanNoExpiration);
            return;
        }
        if (!curSharedUser.allowedUsers) {
            this.ns.showWarnMessage(this.dic.ERRORS.sharedPlanNoUsers);
            return;
        }
        if (typeof curSharedUser.allowedLicenses !== 'number' || curSharedUser.allowedLicenses < 0) {
            this.ns.showWarnMessage(this.dic.ERRORS.sharedPlanNoInboundLicenses);
            return;
        }
        if (curSharedUser.setAsPartner && !curSharedUser.customerId) {
            this.ns.showWarnMessage(this.dic.ERRORS.sharedPlanNoPartnerId);
            return;
        }
        if (copyPolicyData.enabled && !copyPolicyData.selectedPolicyTemplate) {
            copyPolicyData.error = true;
            this.ns.showErrorMessage(util.format(this.dic.ERRORS.noSelected, 'policy'));
            return;
        }
        if (!curSharedUser.setAsPartner) {
            curSharedUser.customerId = '';
        }

        const expirationDate = this.getPlanExpirationDate(curSharedUser.adminExpirationDate, curSharedUser.extendExpirationMethod, curSharedUser.planSubType);
        const userDomain = this.gs.getDomain(curSharedUser.email);
        this.stopActiveUserPopup = true;

        const adminInfo: any = {
            resend: false,
            emails: [{email: curSharedUser.email, name: curSharedUser.name}],
            isAdmin: true,
            plan: {
                isManagedPlan: curSharedUser.planManagedBy === this.dic.CONSTANTS.planManagedBy.you,
                domain: curSharedUser.domain,
                planSubType: curSharedUser.planSubType,
                users: curSharedUser.allowedUsers,
                inboundLicenses: curSharedUser.allowedLicenses,
                expired: expirationDate,
                customerId: curSharedUser.customerId,
                company_name: curSharedUser.companyName || curSharedUser.customerId || userDomain,
                extendExpiration: curSharedUser.extendExpirationMethod,
                archive: curSharedUser.archive,
                threat_simulation: curSharedUser.threat_simulation,
                allow_support_wa: curSharedUser.allow_support_wa,
                hide_partner_access: curSharedUser.hide_partner_access,
            }
        };

        if (copyPolicyData.enabled) {
            adminInfo.policy = {
                name: copyPolicyData.selectedPolicyTemplate.name,
                fromAdmin: copyPolicyData.selectedFromAdmin.email
            };
        }

        this.newPlanWizard.inProcess = true;
        this.rs.inviteUserToSharedPlan(adminInfo).then(() => {
            this.mainPlanAdmin.alloc_plan_id.shared_plan.used_users += curSharedUser.allowedUsers;
            this.mainPlanAdmin.alloc_plan_id.threat_protection.used_users += curSharedUser.allowedLicenses;
            let newAdmin: any = {
                name: curSharedUser.name || curSharedUser.email,
                email: curSharedUser.email,
                user_role: this.dic.CONSTANTS.userRole.admin,
                status: this.dic.CONSTANTS.userInPlanStatus.invitationSent,
                is_relay: false,
                customer_id: curSharedUser.customerId,
                customer_admin: !!curSharedUser.customerId,
                alloc_plan_id: {
                    company_name: curSharedUser.companyName || curSharedUser.customerId || userDomain,
                    plan_sub_type: curSharedUser.planSubType,
                    shared_plan: {allowed_users: curSharedUser.allowedUsers},
                    expired: expirationDate,
                    archive: curSharedUser.archive,
                    threat_simulation: curSharedUser.threat_simulation,
                    threat_protection: {allowed_users: curSharedUser.allowedLicenses},
                }
            };

            if (adminInfo.plan.isManagedPlan) {
                newAdmin.status = this.dic.CONSTANTS.userInPlanStatus.active;
                newAdmin.email = `${curSharedUser.domain}@trustifi.com`;
                newAdmin.name = `${curSharedUser.domain} Admin`;
                newAdmin.preferences = {require_2fa: {value: false, strict: false}};
                newAdmin.planUsers = [];
                newAdmin.alloc_plan_id.is_managed = true;
                if (this.gs.planAdmins?.length && !curSharedUser.hide_partner_access) {
                    this.gs.planAdmins.push({email: newAdmin.email});
                    this.gs.updatePlanAdminsSubj.next({planAdmins: this.gs.planAdmins, init: false});
                }
                this.ns.showInfoMessage(util.format(this.dic.MESSAGES.userMgmtCreatePlanDomain, curSharedUser.domain));
            } else {
                this.ns.showInfoMessage(this.dic.MESSAGES.userMgmtInvite);
            }

            this.setEmailAndRoleDisplay(newAdmin, this.mainPlanAdmin);
            this.sharedPlanInfo.users.push(newAdmin);
            this.updateListView(this.usersListView);
            this.stopActiveUserPopup = false;
            this.newPlanWizard = null;
        }, (err) => {
            if (err?.data?.message && !err.data.display_bar) {
                this.ns.showErrorMessage(err.data.message);
            }
            this.newPlanWizard.inProcess = false;
            this.stopActiveUserPopup = false;
        });
    };

    addPlanTemplate = () => {
        const curSharedUser = this.newPlanWizard.curSharedUser;
        const selectPlanTemplateType = this.newPlanWizard.selectPlanTemplateType;

        if (!curSharedUser.templateName?.trim()) {
            this.ns.showWarnMessage(util.format(DICTIONARY.ERRORS.emptyField, 'Template name'));
            return;
        }

        const templateName = curSharedUser.templateName.trim().toLowerCase().replace(/\s+/g, '-');

        if (!this.gs.validateEmail(templateName + '@dummy.com')) {
            this.ns.showWarnMessage(util.format(DICTIONARY.ERRORS.emptyField, 'Template name contains invalid characters'));
            return;
        }

        const actionInfo: any = {
            isTemplate: true,
            templateName: templateName,
        };

        if (selectPlanTemplateType === 'duplicate') {
            if (!curSharedUser.selectedDefaultTemplate) {
                this.ns.showWarnMessage(util.format(this.dic.ERRORS.noSelected, 'template'));
                return;
            }
            actionInfo.default_template = curSharedUser.selectedDefaultTemplate.name;
        }

        this.newPlanWizard.inProcess = true;
        this.rs.inviteUserToSharedPlan(actionInfo).then(() => {
            this.gs.planAdmins.push({email: `${actionInfo.templateName}@trustifi.com`, name: actionInfo.templateName, isTemplate: true});
            this.gs.updatePlanAdminsSubj.next({planAdmins: this.gs.planAdmins, init: false});
            this.ns.showInfoMessage(util.format(this.dic.MESSAGES.userMgmtCreatePlanDomain, actionInfo.templateName));
            this.newPlanWizard = null;
            this.ngOnInit();
        }, () => {
            this.newPlanWizard.inProcess = false;
        });
    };

    removeUserFromSharedPlan = (sharedUser) => {
        if (!sharedUser.length) {
            return;
        }

        let title, subTitle, body;
        if (sharedUser.length === 1) {
            body = ['User will be removed from the plan.'];
            title = 'Remove User';
            subTitle = `Remove ${sharedUser[0].email} from the current plan`;
        }
        else {
            body = [`${sharedUser.length} users will be removed from the plan.`];
            title = `Remove ${sharedUser.length} users`;
            subTitle = `Remove ${sharedUser.length} users from the current plan`;
        }

        for (let idx = 0; idx < sharedUser.length; idx++) {
            if (sharedUser[idx].user_role === this.dic.CONSTANTS.userRole.admin && sharedUser[idx].status === this.dic.CONSTANTS.userInPlanStatus.active) {
                this.ns.showWarnMessage(util.format(this.dic.ERRORS.sharedPlanRemoveAdmin, sharedUser[idx].email));
                return;
            }
        }

        this.gs.showPopup({
            title: title,
            subTitle: subTitle,
            body: body,
            type: this.dic.CONSTANTS.popupWarning,
            doneBtnText: 'Remove',
            doneCb: () => {
                sharedUser.forEach((userObj) => {
                    this.rs.removeUserFromSharedPlan({userToRemove: userObj.email, action: 'remove'}).then(() => {
                        _.remove<any>(this.sharedPlanInfo.users, user => user.email === userObj.email);
                        this.updateListView(this.usersListView);

                        this.mainPlanAdmin.alloc_plan_id.shared_plan.used_users--;
                        if (userObj.alloc_plan_id) {
                            this.mainPlanAdmin.alloc_plan_id.threat_protection.used_users -= userObj.alloc_plan_id.threat_protection.allowed_users;
                        }
                    });
                });
            }
        });
    };

    updateAdminPlan = (sharedUser, isUpdate) => {
        if (isUpdate && sharedUser.user_role !== this.dic.CONSTANTS.userRole.admin) {
            return;
        }
        if (isUpdate && !this.isPartnerAdmin) {
            return;
        }

        const curSharedUser = sharedUser || {};
        curSharedUser.invoiceNotify = null;
        curSharedUser.errMsg = '';
        curSharedUser.isExtendExpirationMenuOpen = false;
        curSharedUser.extendExpirationMethod = '';
        curSharedUser.newExpirationDate = null;

        const currentAdminObj = curSharedUser.depth && curSharedUser.parent
            ? this.sharedPlanInfo.users.find(itm => itm.email === curSharedUser.parent)
            : this.mainPlanAdmin;

        if (isUpdate) {
            curSharedUser.allowedUsers = curSharedUser.alloc_plan_id.shared_plan.allowed_users || 1;
            curSharedUser.allowedLicenses = curSharedUser.alloc_plan_id.threat_protection.allowed_users || 0;
            curSharedUser.planSubType = curSharedUser.alloc_plan_id.plan_sub_type;
            curSharedUser.customerId = curSharedUser.alloc_plan_id.customer_id;
            if (curSharedUser.alloc_plan_id.customer_id) {
                curSharedUser.setAsPartner = true;
            }
            curSharedUser.companyName = curSharedUser.alloc_plan_id.company_name;
            curSharedUser.archive = curSharedUser.alloc_plan_id.archive || false;
            curSharedUser.threat_simulation = curSharedUser.alloc_plan_id.threat_simulation || false;
            curSharedUser.allow_support_wa = curSharedUser.alloc_plan_id.allow_support_wa || false;
        } else {
            curSharedUser.adminExpirationDate = new Date();
            curSharedUser.allow_support_wa = true;
        }

        this.newPlanWizard = {
            mode: isUpdate ? 'modify' : 'allocate',
            curSharedUser,
            copyPolicyData: {
                enabled: false,
                selectedFromAdmin: this.gs.controlAdmin,
                selectedPolicyTemplate: null,
            },
            sharedPlanInfo: this.sharedPlanInfo,
            currentAdminObj,
            planPolicies: this.planPolicies,
            adminExpirationDateMinString: this.adminExpirationDateMinString,
            adminExpirationDateMaxString: this.adminExpirationDateMaxString,
            confirmCb: () => {
                if (isUpdate) {
                    this.updateAdminPlanExecute();
                } else {
                    this.setUserAsAdmin();
                }
            },
            closeCb: () => {
                this.newPlanWizard = null;
            },
        };
    };

	modifyUserPermissionsPopup = (userObj) => {
		const tabs = {
			adminPermissions: 'Plan Admin',
			planReviewer: 'Plan Reviewer'
		};
		if (this.sharedPlanInfo.customer_id) {
			tabs['globalReviewer'] = 'Global Reviewer';
		}

		this.userPermissionPopup = {
			activeTab: tabs.adminPermissions,
			tabs: tabs,
			userObj: userObj,
			isSubAdmin: userObj.user_role === this.dic.CONSTANTS.userRole.subAdmin,
			isOutboundReviewer: this.sharedPlanInfo.reviewers?.outbound?.some(itm => itm.email === userObj.email),
			isInboundReviewer: this.sharedPlanInfo.reviewers?.inbound?.some(itm => itm.email === userObj.email),
			isThreatSimulationReviewer: this.sharedPlanInfo.reviewers?.threat_simulation?.some(itm => itm.email === userObj.email),
			isArchiveReviewer: this.sharedPlanInfo.reviewers?.archive?.some(itm => itm.email === userObj.email),
			isAcpReviewer: this.sharedPlanInfo.reviewers?.account_compromised?.some(itm => itm.email === userObj.email),
			isCollabReviewer: this.sharedPlanInfo.reviewers?.collaboration_protection?.some(itm => itm.email === userObj.email),
			isPartnerReviewer: this.sharedPlanInfo.reviewers?.partners?.some(itm => itm.email === userObj.email),
			readOnly: userObj.read_only,
			show_multi_tenant: userObj.show_multi_tenant,
			managed_plans_only: userObj.managed_plans_only,
			show: true
		};
	};

	// CC: technician role - admin on managed plans only (mirrors modifyUserMultiTenantViewExecute)
	modifyUserManagedPlansOnlyExecute = () => {
		if (this.userPermissionPopup.inProcess) {
			return;
		}
		this.userPermissionPopup.inProcess = true;

		const statusUpdate = {
			enabled: this.userPermissionPopup.managed_plans_only,
			action: this.dic.CONSTANTS.planAdminActions.managedPlansOnly,
			depth: this.userPermissionPopup.userObj.depth,
			parent: this.userPermissionPopup.userObj.parent
		};
		this.rs.doActionOnPlanAdmin(this.userPermissionPopup.userObj.email, statusUpdate).then((response) => {
			this.userPermissionPopup.userObj.managed_plans_only = statusUpdate.enabled;
			// CC: the server forces multi tenant view on for technicians
			if (statusUpdate.enabled) {
				this.userPermissionPopup.show_multi_tenant = true;
				this.userPermissionPopup.userObj.show_multi_tenant = true;
			}
			this.setRolePriority(this.userPermissionPopup.userObj, this.userPermissionPopup.userObj.depth && this.userPermissionPopup.userObj.parent ?
				this.sharedPlanInfo.users.find(itm => itm.email === this.userPermissionPopup.userObj.parent) : this.mainPlanAdmin);

			this.ns.showInfoMessage(response.log);
			this.userPermissionPopup.inProcess = false;
		}, () => {
			this.userPermissionPopup.managed_plans_only = !statusUpdate.enabled;
			this.userPermissionPopup.inProcess = false;
		});
	};

	modifyUserPermissionsExecute = () => {
		if (this.userPermissionPopup.inProcess) {
			return;
		}
		this.userPermissionPopup.inProcess = true;

		const statusUpdate = {
			enabled: this.userPermissionPopup.isSubAdmin,
			action: this.dic.CONSTANTS.planAdminActions.subAdmin,
			depth: this.userPermissionPopup.userObj.depth,
			parent: this.userPermissionPopup.userObj.parent
		};
		this.rs.doActionOnPlanAdmin(this.userPermissionPopup.userObj.email, statusUpdate).then( (response) => {
			this.userPermissionPopup.userObj.user_role = statusUpdate.enabled ? this.dic.CONSTANTS.userRole.subAdmin : this.dic.CONSTANTS.userRole.user;

			if (!statusUpdate.enabled) {
				this.userPermissionPopup.userObj.customer_user_role = null;
			}

			const currentAdminObj = this.userPermissionPopup.userObj.depth && this.userPermissionPopup.userObj.parent ?
				this.sharedPlanInfo.users.find(itm => itm.email === this.userPermissionPopup.userObj.parent) :
				this.mainPlanAdmin;

			this.setRolePriority(this.userPermissionPopup.userObj, currentAdminObj);

			if (!statusUpdate.enabled && this.userPermissionPopup.userObj.email === this.userInfo.email) {
				this.router.navigate([this.dic.CONSTANTS.appStates.home]);
			}

			this.ns.showInfoMessage(response.log);
			this.userPermissionPopup.inProcess = false;
		}, () => {
			this.userPermissionPopup.inProcess = false;
		});
	};

	modifyUserReadOnlyExecute = () => {
		if (this.userPermissionPopup.inProcess) {
			return;
		}
		this.userPermissionPopup.inProcess = true;

		const statusUpdate = {
			enabled: this.userPermissionPopup.readOnly,
			action: this.dic.CONSTANTS.planAdminActions.readOnly,
			depth: this.userPermissionPopup.userObj.depth,
			parent: this.userPermissionPopup.userObj.parent
		};
		this.rs.doActionOnPlanAdmin(this.userPermissionPopup.userObj.email, statusUpdate).then( (response) => {
			this.userPermissionPopup.userObj.read_only = statusUpdate.enabled;

			this.ns.showInfoMessage(response.log);
			this.userPermissionPopup.inProcess = false;
		}, () => {
			this.userPermissionPopup.inProcess = false;
		});
	};

	modifyUserMultiTenantViewExecute = () => {
		if (this.userPermissionPopup.inProcess) {
			return;
		}
		this.userPermissionPopup.inProcess = true;

		const statusUpdate = {
			enabled: this.userPermissionPopup.show_multi_tenant,
			action: this.dic.CONSTANTS.planAdminActions.multiTenantView,
			depth: this.userPermissionPopup.userObj.depth,
			parent: this.userPermissionPopup.userObj.parent
		};
		this.rs.doActionOnPlanAdmin(this.userPermissionPopup.userObj.email, statusUpdate).then( (response) => {
			this.userPermissionPopup.show_multi_tenant = statusUpdate.enabled;

			this.ns.showInfoMessage(response.log);
			this.userPermissionPopup.inProcess = false;
		}, () => {
			this.userPermissionPopup.show_multi_tenant = !statusUpdate.enabled;
			this.userPermissionPopup.inProcess = false;
		});
	};

	modifyUserReviewerExecute = (type) => {
		if (this.userPermissionPopup.inProcess) {
			return;
		}
		this.userPermissionPopup.inProcess = true;

		switch (type) {
			case 'outbound':
				if (this.userPermissionPopup.isOutboundReviewer) {
					this.rs.addOutboundReviewer(this.userPermissionPopup.userObj.email, {}).then(res => {
						this.ns.showInfoMessage(util.format(this.dic.MESSAGES.itemAdded, 'Reviewer'));
						this.sharedPlanInfo.reviewers?.outbound.push({email: this.userPermissionPopup.userObj.email});
						this.userPermissionPopup.inProcess = false;
						this.setReviewerDisplay(this.userPermissionPopup.userObj);
					}, () => {
						this.userPermissionPopup.inProcess = false;
					});
				}
				else {
					this.rs.deleteOutboundReviewer(this.userPermissionPopup.userObj.email).then(res => {
						this.userPermissionPopup.inProcess = false;
						_.remove<any>(this.sharedPlanInfo.reviewers?.outbound, itm => itm.email === this.userPermissionPopup.userObj.email);
						this.ns.showInfoMessage(util.format(this.dic.MESSAGES.itemDeleted, 'Reviewer', this.userPermissionPopup.userObj.email));
						this.setReviewerDisplay(this.userPermissionPopup.userObj);
					}, () => {
						this.userPermissionPopup.inProcess = false;
					});
				}
				break;

			case 'inbound':
				const data = {
					action: this.dic.CONSTANTS.inboundConfigurationsActions.add,
					emails: [this.userPermissionPopup.userObj.email]
				};
				if (this.userPermissionPopup.isInboundReviewer) {
					data.action = this.dic.CONSTANTS.inboundConfigurationsActions.add;
					this.rs.updateInboundReviewers(data).then(res => {
						this.sharedPlanInfo.reviewers?.inbound.push({email: this.userPermissionPopup.userObj.email});
						this.ns.showInfoMessage(util.format(this.dic.MESSAGES.itemAdded, 'Reviewer'));
						this.userPermissionPopup.inProcess = false;
						this.setReviewerDisplay(this.userPermissionPopup.userObj);
					}, () => {
						this.userPermissionPopup.inProcess = false;
					});
				}
				else {
					data.action = this.dic.CONSTANTS.inboundConfigurationsActions.remove;
					this.rs.updateTpConfig(data).then(res => {
						this.userPermissionPopup.inProcess = false;
						_.remove<any>(this.sharedPlanInfo.reviewers?.inbound, itm => itm.email === this.userPermissionPopup.userObj.email);
						this.ns.showInfoMessage(util.format(this.dic.MESSAGES.itemDeleted, 'Reviewer', this.userPermissionPopup.userObj.email));
						this.setReviewerDisplay(this.userPermissionPopup.userObj);
					}, () => {
						this.userPermissionPopup.inProcess = false;
					});
				}
				break;

			case 'threat_simulation':
				if (this.userPermissionPopup.isThreatSimulationReviewer) {
					this.rs.addThreatSimulationReviewer(this.userPermissionPopup.userObj.email).then(res => {
						this.sharedPlanInfo.reviewers?.threat_simulation.push({email: this.userPermissionPopup.userObj.email});
						this.ns.showInfoMessage(util.format(this.dic.MESSAGES.itemAdded, 'Reviewer'));
						this.userPermissionPopup.inProcess = false;
						this.setReviewerDisplay(this.userPermissionPopup.userObj);
					}, () => {
						this.userPermissionPopup.isThreatSimulationReviewer = false;
						this.userPermissionPopup.inProcess = false;
					});
				}
				else {
					this.rs.deleteThreatSimulationReviewer(this.userPermissionPopup.userObj.email).then(res => {
						this.userPermissionPopup.inProcess = false;
						_.remove<any>(this.sharedPlanInfo.reviewers?.threat_simulation, itm => itm.email === this.userPermissionPopup.userObj.email);
						this.ns.showInfoMessage(util.format(this.dic.MESSAGES.itemDeleted, 'Reviewer', this.userPermissionPopup.userObj.email));
						this.setReviewerDisplay(this.userPermissionPopup.userObj);
					}, () => {
						this.userPermissionPopup.inProcess = false;
					});
				}
				break;

			case 'archive':
				if (this.userPermissionPopup.isArchiveReviewer) {
					this.rs.addArchiveReviewer(this.userPermissionPopup.userObj.email, {}).then(res => {
						this.sharedPlanInfo.reviewers?.archive.push({email: this.userPermissionPopup.userObj.email});
						this.ns.showInfoMessage(util.format(this.dic.MESSAGES.itemAdded, 'Reviewer'));
						this.userPermissionPopup.inProcess = false;
						this.setReviewerDisplay(this.userPermissionPopup.userObj);
					}, () => {
						this.userPermissionPopup.inProcess = false;
					});
				}
				else {
					this.rs.deleteArchiveReviewer(this.userPermissionPopup.userObj.email).then(res => {
						this.userPermissionPopup.inProcess = false;
						_.remove<any>(this.sharedPlanInfo.reviewers?.archive, itm => itm.email === this.userPermissionPopup.userObj.email);
						this.ns.showInfoMessage(util.format(this.dic.MESSAGES.itemDeleted, 'Reviewer', this.userPermissionPopup.userObj.email));
						this.setReviewerDisplay(this.userPermissionPopup.userObj);
					}, () => {
						this.userPermissionPopup.inProcess = false;
					});
				}
				break;

			case 'account_compromised':
				if (this.userPermissionPopup.isAcpReviewer) {
					this.rs.addAccountCompromisedReviewer(this.userPermissionPopup.userObj.email, {}).then(res => {
						this.ns.showInfoMessage(util.format(this.dic.MESSAGES.itemAdded, 'Reviewer'));
						this.sharedPlanInfo.reviewers?.account_compromised.push({email: this.userPermissionPopup.userObj.email});
						this.setReviewerDisplay(this.userPermissionPopup.userObj);
						this.userPermissionPopup.inProcess = false;
					}, () => {
						this.userPermissionPopup.inProcess = false;
					});
				}
				else {
					this.rs.deleteAccountCompromisedReviewer(this.userPermissionPopup.userObj.email).then(res => {
						_.remove<any>(this.sharedPlanInfo.reviewers?.account_compromised, itm => itm.email === this.userPermissionPopup.userObj.email);
						this.userPermissionPopup.inProcess = false;
						this.setReviewerDisplay(this.userPermissionPopup.userObj);
						this.ns.showInfoMessage(util.format(this.dic.MESSAGES.itemDeleted, 'Reviewer', this.userPermissionPopup.userObj.email));
					}, () => {
						this.userPermissionPopup.inProcess = false;
					});
				}
				break;

			case 'collaboration_protection':
				if (this.userPermissionPopup.isCollabReviewer) {
					this.rs.addCollaborationReviewer(this.userPermissionPopup.userObj.email, {}).then(res => {
						this.ns.showInfoMessage(util.format(this.dic.MESSAGES.itemAdded, 'Reviewer'));
						this.sharedPlanInfo.reviewers?.collaboration_protection.push({email: this.userPermissionPopup.userObj.email});
						this.setReviewerDisplay(this.userPermissionPopup.userObj);
						this.userPermissionPopup.inProcess = false;
					}, () => {
						this.userPermissionPopup.inProcess = false;
					});
				}
				else {
					this.rs.deleteCollaborationReviewer(this.userPermissionPopup.userObj.email).then(res => {
						_.remove<any>(this.sharedPlanInfo.reviewers?.collaboration_protection, itm => itm.email === this.userPermissionPopup.userObj.email);
						this.userPermissionPopup.inProcess = false;
						this.setReviewerDisplay(this.userPermissionPopup.userObj);
						this.ns.showInfoMessage(util.format(this.dic.MESSAGES.itemDeleted, 'Reviewer', this.userPermissionPopup.userObj.email));
					}, () => {
						this.userPermissionPopup.inProcess = false;
					});
				}
				break;

			case 'partner':
				if (this.userPermissionPopup.isPartnerReviewer) {
					this.rs.addPartnerReviewer(this.userPermissionPopup.userObj.email).then(res => {
						this.ns.showInfoMessage(util.format(this.dic.MESSAGES.itemAdded, 'Reviewer'));
						this.sharedPlanInfo.reviewers?.partners.push({email: this.userPermissionPopup.userObj.email});
						this.setReviewerDisplay(this.userPermissionPopup.userObj);
						this.userPermissionPopup.inProcess = false;
					}, () => {
						this.userPermissionPopup.inProcess = false;
					});
				}
				else {
					this.rs.deletePartnerReviewer(this.userPermissionPopup.userObj.email).then(res => {
						_.remove<any>(this.sharedPlanInfo.reviewers?.partners, itm => itm.email === this.userPermissionPopup.userObj.email);
						this.userPermissionPopup.inProcess = false;
						this.setReviewerDisplay(this.userPermissionPopup.userObj);
						this.ns.showInfoMessage(util.format(this.dic.MESSAGES.itemDeleted, 'Reviewer', this.userPermissionPopup.userObj.email));
					}, () => {
						this.userPermissionPopup.inProcess = false;
					});
				}
				break;
		}
	};



	setRolePriority = (user, admin) => {
		if (this.isTemplatePlan(user)) {
			user.user_role_display = 'Template Plan';
			user.role_priority = 6;
			return;
		}

        if (user.email === admin.email) {
            user.role_priority = 1;
            user.user_role_display = admin.alloc_plan_id.customer_id ? admin.alloc_plan_id.customer_id +" Admin" : "Admin";
            user.company_name_display = user.alloc_plan_id && user.alloc_plan_id.company_name || 'N/A';
            if (admin.alloc_plan_id.customer_id && !this.rolesExisting.includes(admin.alloc_plan_id.customer_id + ' Admin')) {
                this.rolesExisting.push(admin.alloc_plan_id.customer_id + ' Admin');
            }
            if (user.company_name_display && !this.companyNamesExisting.includes(user.company_name_display)) {
                this.companyNamesExisting.push(user.company_name_display);
            }
        }
        else {
            if (user.user_role === this.dic.CONSTANTS.userRole.admin) {
                const customerId = user.alloc_plan_id && user.alloc_plan_id.customer_id;
                if (customerId) {
                    user.role_priority = 3;
                    user.user_role_display = `${customerId} Admin`;
                    if (!this.rolesExisting.includes(customerId + ' Admin')) {
                        this.rolesExisting.push(customerId + ' Admin');
                    }
                }
                else {
                    user.role_priority = 4;
                    user.user_role_display = `Plan Admin`;
                }
                user.company_name_display = user.alloc_plan_id && user.alloc_plan_id.company_name || 'N/A';
                if (user.company_name_display && !this.companyNamesExisting.includes(user.company_name_display)) {
                    this.companyNamesExisting.push(user.company_name_display);
                }
                if (user.alloc_plan_id && user.alloc_plan_id.is_managed) {
                    user.user_role_display = 'Managed Plan';
                    user.role_priority = 5;
                }
            }
            else {
                if (user.user_role === this.dic.CONSTANTS.userRole.subAdmin) {
                    user.role_priority = 2;
                    user.user_role_display = admin.alloc_plan_id.customer_id ? admin.alloc_plan_id.customer_id + " Admin" : "Admin";
                    // CC: technician - admin on managed plans only
                    if (user.managed_plans_only && admin.alloc_plan_id.customer_id) {
                        user.user_role_display = admin.alloc_plan_id.customer_id + " Technician";
                    }
                }
                else {
                    user.role_priority = 6;
                    user.user_role_display = 'User';
                }
                user.company_name_display = admin.alloc_plan_id && admin.alloc_plan_id.company_name || 'N/A';
            }
        }

		if (user.global_reviewer?.inbound?.enabled || user.global_reviewer?.outbound?.enabled
			|| user.global_reviewer?.archive?.enabled || user.global_reviewer?.threat_simulation?.enabled || user.global_reviewer?.account_compromised?.enabled) {
			user.role_priority = 5.8; // before user
			user.user_role_display += ' (Global Reviewer)';
		}

		this.setReviewerDisplay(user);
    };

	setReviewerDisplay = (user) => {
		user.user_reviewer = '';
		// Archive, Inbound, Outbound, Account Takeover
		if (this.sharedPlanInfo.reviewers) {
			if (this.sharedPlanInfo.reviewers.outbound?.find(itm => itm.email === user.email)) {
				user.user_reviewer += `Outbound`;
			}
			if (this.sharedPlanInfo.reviewers.inbound?.find(itm => itm.email === user.email)) {
				user.user_reviewer += user.user_reviewer ? ', Inbound' : `Inbound`;
			}
			if (this.sharedPlanInfo.reviewers.archive?.find(itm => itm.email === user.email)) {
				user.user_reviewer += user.user_reviewer ? ', Archive' : `Archive`;
			}
			if (this.sharedPlanInfo.reviewers.account_compromised?.find(itm => itm.email === user.email)) {
				user.user_reviewer += user.user_reviewer ? ', Account Takeover' : `Account Takeover`;
			}
			if (this.sharedPlanInfo.reviewers.threat_simulation?.find(itm => itm.email === user.email)) {
				user.user_reviewer += user.user_reviewer ? ', Threat Simulation' : `Threat Simulation`;
			}
			if (this.sharedPlanInfo.reviewers.partners?.find(itm => itm.email === user.email)) {
				user.user_reviewer += user.user_reviewer ? ', Partner' : `Partner`;
			}
		}
	}


    updateAdminPlanExecute = () => {
        const curSharedUser = this.newPlanWizard.curSharedUser;

        if (!curSharedUser.adminExpirationDate) {
            curSharedUser.errMsg = this.dic.ERRORS.sharedPlanNoExpiration;
            return;
        }
        if (!curSharedUser.allowedUsers) {
            curSharedUser.errMsg = this.dic.ERRORS.sharedPlanNoUsers;
            return;
        }
        if (typeof curSharedUser.allowedLicenses !== 'number' || curSharedUser.allowedLicenses < 0) {
            curSharedUser.errMsg = this.dic.ERRORS.sharedPlanNoInboundLicenses;
            return;
        }
        if (curSharedUser.setAsPartner && !curSharedUser.customerId) {
            curSharedUser.errMsg = this.dic.ERRORS.sharedPlanNoPartnerId;
            return;
        }
        if (!curSharedUser.setAsPartner) {
            curSharedUser.customerId = '';
        }

        const userDomain = this.gs.getDomain(curSharedUser.email);
        curSharedUser.errMsg = '';
        this.newPlanWizard.inProcess = true;
        const expirationDate = this.getPlanExpirationDate(curSharedUser.adminExpirationDate, curSharedUser.extendExpirationMethod, curSharedUser.planSubType);

        const actionInfo = {
            action: this.dic.CONSTANTS.planAdminActions.modifyPlan,
            depth: curSharedUser.depth,
            parent: curSharedUser.parent,
            plan: {
                planSubType: curSharedUser.planSubType,
                users: curSharedUser.allowedUsers,
                inboundLicenses: curSharedUser.allowedLicenses,
                expired: expirationDate,
                customerId: curSharedUser.customerId,
                company_name: curSharedUser.companyName || curSharedUser.customerId || userDomain,
                archive: curSharedUser.archive,
                threat_simulation: curSharedUser.threat_simulation,
                allow_support_wa: curSharedUser.allow_support_wa,
                hide_partner_access: curSharedUser.hide_partner_access,
                extendExpiration: curSharedUser.extendExpirationMethod,
            }
        };

        this.rs.doActionOnPlanAdmin(curSharedUser.email, actionInfo).then(() => {
            this.newPlanWizard = null;

            const parentAdmin = curSharedUser.depth && curSharedUser.parent
                ? this.sharedPlanInfo.users.find(itm => itm.email === curSharedUser.parent)
                : this.mainPlanAdmin;

            parentAdmin.alloc_plan_id.shared_plan.used_users = parentAdmin.alloc_plan_id.shared_plan.used_users + curSharedUser.allowedUsers - curSharedUser.alloc_plan_id.shared_plan.allowed_users;
            parentAdmin.alloc_plan_id.threat_protection.used_users = parentAdmin.alloc_plan_id.threat_protection.used_users + curSharedUser.allowedLicenses - curSharedUser.alloc_plan_id.threat_protection.allowed_users;

            curSharedUser.alloc_plan_id.shared_plan.allowed_users = curSharedUser.allowedUsers;
            curSharedUser.alloc_plan_id.threat_protection.allowed_users = curSharedUser.allowedLicenses;
            curSharedUser.alloc_plan_id.archive = curSharedUser.archive;
            curSharedUser.alloc_plan_id.threat_simulation = curSharedUser.threat_simulation;
            curSharedUser.alloc_plan_id.plan_sub_type = curSharedUser.planSubType;
            curSharedUser.alloc_plan_id.expired = expirationDate;
            curSharedUser.alloc_plan_id.customer_id = curSharedUser.customerId;
            curSharedUser.hide_partner_access = curSharedUser.hide_partner_access;
            curSharedUser.alloc_plan_id.company_name = curSharedUser.companyName || curSharedUser.customerId || userDomain;
            curSharedUser.customer_id = curSharedUser.customerId;
            this.setRolePriority(curSharedUser, this.mainPlanAdmin);
            if (curSharedUser.planUsers) {
                for (let idx = 0; idx < curSharedUser.planUsers.length; idx++) {
                    curSharedUser.planUsers[idx].customer_id = curSharedUser.customerId;
                    this.setRolePriority(curSharedUser.planUsers[idx], this.mainPlanAdmin);
                }
            }
            if (this.isCompanyView) {
                this.createCompanyGroups();
            }
            this.gs.filterPlansWithNoPartnerAccess(curSharedUser.email, curSharedUser.hide_partner_access);
        }, (err) => {
            if (err?.data?.message) {
                this.ns.showErrorMessage(err.data.message);
            }
            this.newPlanWizard.inProcess = false;
        });
    };

    resendInviteToSharedPlan = (sharedUser) => {
        this.gs.showPopup({
            title: 'Resend User Invitation',
            subTitle: 'Resend the invitation email to join your plan',
            body: [`You are about to resend an invitation to ${sharedUser.name || sharedUser.email}`],
            type: this.dic.CONSTANTS.popupInfo,
            doneBtnText: 'Resend',
            doneCb: () => {
                this.rs.inviteUserToSharedPlan({
                    resend: true,
                    emails: [{email: sharedUser.email, name: sharedUser.name || sharedUser.email}],
                    isAdmin: sharedUser.user_role === this.dic.CONSTANTS.userRole.admin
                }).then(() => {
                    this.ns.showInfoMessage(this.dic.MESSAGES.userMgmtInvite);
                });
            }
        });
    };

    downgradeAdmin = (sharedUser) => {
        if (!sharedUser) {
            return;
        }

        this.curSharedUser = sharedUser;
        this.gs.showPopup({
            title: this.dic.CONSTANTS.userActions.removePlan,
            subTitle: `${sharedUser.name}'s plan will be removed`,
            body: [
                'Resources will be returned to your plan',
                'All users under the plan will be removed from the plan'
            ],
            type: this.dic.CONSTANTS.popupWarning,
            doneBtnText: this.dic.CONSTANTS.userActions.removePlan,
            doneCb: this.downgradeAdminExecute
        });
    };

    downgradeAdminExecute = () => {
        if (!this.curSharedUser) {
            return;
        }

        const actionInfo = {
            action: this.dic.CONSTANTS.planAdminActions.downgradePlan,
            depth: this.curSharedUser.depth,
            parent: this.curSharedUser.parent,
        }
        this.rs.doActionOnPlanAdmin(this.curSharedUser.email, actionInfo).then(() => {
            const currentAdminObj = this.curSharedUser.depth && this.curSharedUser.parent ?
                this.sharedPlanInfo.users.find(itm => itm.email === this.curSharedUser.parent) :
                this.mainPlanAdmin;

            if (this.curSharedUser.alloc_plan_id?.is_managed || this.isTemplatePlan(this.curSharedUser)) {
                _.remove<any>(this.sharedPlanInfo.users, user => user.email === this.curSharedUser.email);
                this.updateListView(this.usersListView);
            }
            else {
                this.curSharedUser.user_role = this.dic.CONSTANTS.userRole.user;
                this.setRolePriority(this.curSharedUser, currentAdminObj);
            }

            currentAdminObj.alloc_plan_id.shared_plan.used_users = currentAdminObj.alloc_plan_id.shared_plan.used_users - this.curSharedUser.alloc_plan_id.shared_plan.allowed_users + 1;
            currentAdminObj.alloc_plan_id.threat_protection.used_users -= this.curSharedUser.alloc_plan_id.threat_protection.allowed_users;

            if (this.curSharedUser.planUsers && this.curSharedUser.planUsers.length) {
                this.curSharedUser.planUsers = [];
            }
            this.curSharedUser.alloc_plan_id = null;
            if (this.gs.planAdmins?.length) {
                _.remove<any>(this.gs.planAdmins, a => a.email === this.curSharedUser.email);
				this.gs.updatePlanAdminsSubj.next({planAdmins: this.gs.planAdmins, init: false});
			}
        });
    };

    updateUserStatusInPlan = (userObj, isBlocked) => {
        if (!userObj) {
            return;
        }

        const title = isBlocked ? this.dic.CONSTANTS.userActions.block : this.dic.CONSTANTS.userActions.unblock;
        const connector = isBlocked ? 'not ': '';
        let subTitle;
        if (userObj.user_role === this.dic.CONSTANTS.userRole.admin) {
            subTitle = `${title} ${userObj.name}'s plan - users under this plan will ${connector}be able to access their account`;
        }
        else {
            subTitle = `${title} ${userObj.name} - user will ${connector}be able to access their account`;
        }
        this.gs.showPopup({
            title: title,
            subTitle: subTitle,
            body: [],
            type: this.dic.CONSTANTS.popupWarning,
            doneBtnText: title,
            doneCb: () => {
                const actionInfo = {
                    action: this.dic.CONSTANTS.planUsersActions.status,
                    isAdmin: userObj.user_role === this.dic.CONSTANTS.userRole.admin,
                    block: isBlocked,
                    depth: userObj.depth,
                    parent: userObj.parent
                };
                this.rs.doActionOnPlanUser(userObj.email, actionInfo).then(() => {
                    userObj.status = isBlocked ? userObj.user_role === this.dic.CONSTANTS.userRole.admin ? this.dic.CONSTANTS.userInPlanStatus.planBlocked
                        : this.dic.CONSTANTS.userInPlanStatus.blocked : this.dic.CONSTANTS.userInPlanStatus.active;
                    this.ns.showInfoMessage(this.dic.MESSAGES.planUserUpdated);

					this.getUserStatusTooltip(userObj);
				});
            }
        });
    };

    addActiveUser = () => {
        this.getAllContacts();
        if (!this.mainPlanAdmin) {
            return;
        }
        this.rs.getInviteCustomizedTemplate().then( (template) => {
			this.template = template;
			this.template.html = this.template.html.replace('{{COMPANY_COLOR}}', this.lfs.color);
			this.template.originalHtml = _.cloneDeep(this.template.html);
            this.users = [];

            this.addActiveUserPopup = {
				show: true,
				adminPermissions: false
			};
        });
    };

    addActiveAdmin = () => {
        this.newPlanWizard = {
            mode: 'create',
            selectPlanTemplateType: 'new',
            curSharedUser: {
                setAsPartner: false,
                planManagedBy: this.dic.CONSTANTS.planManagedBy.you,
                allow_support_wa: true,
                hide_partner_access: false,
            },
            copyPolicyData: {
                enabled: false,
                selectedFromAdmin: this.gs.controlAdmin,
                selectedPolicyTemplate: null,
            },
            sharedPlanInfo: this.sharedPlanInfo,
            currentAdminObj: this.mainPlanAdmin,
            planPolicies: this.planPolicies,
            adminExpirationDateMinString: this.adminExpirationDateMinString,
            adminExpirationDateMaxString: this.adminExpirationDateMaxString,
            confirmCb: () => {
                this.addAdminToSharedPlan();
            },
            closeCb: () => {
                this.newPlanWizard = null;
            },
        };
    };

    selectUserAction = (user, action) => {
        switch (action) {
            case this.dic.CONSTANTS.userActions.updateUserSettings:
                this.openChangeUserNamePopup(user);
                break;

            case this.dic.CONSTANTS.userActions.setTimezone:
                this.openSetUserTimezonePopup([user]);
                break;

            case this.dic.CONSTANTS.userActions.modifyResources:
                this.updateAdminPlan(user, true);
                break;

            case this.dic.CONSTANTS.userActions.remove:
                this.removeUserFromSharedPlan([user]);
                break;

            case this.dic.CONSTANTS.userActions.removePlan:
                this.downgradeAdmin(user);
                break;

            case this.dic.CONSTANTS.userActions.block:
                this.updateUserStatusInPlan(user, true);
                break;

            case this.dic.CONSTANTS.userActions.unblock:
                this.updateUserStatusInPlan(user, false);
                break;

            case this.dic.CONSTANTS.userActions.resendInvitation:
                this.resendInviteToSharedPlan(user);
                break;

            case this.dic.CONSTANTS.userActions.allocatePlan:
                this.updateAdminPlan(user, false);
                break;

            case this.dic.CONSTANTS.userActions.moveToOtherAdmin:
                this.openMoveUserToAdminPopup(user);
                break;

            case this.dic.CONSTANTS.userActions.modifyUserPermissions:
                this.modifyUserPermissionsPopup(user);
                break;

            case this.dic.CONSTANTS.userActions.loginMfa:
                this.toggleMFAForPlanUsers([user]);
                break;

            case this.dic.CONSTANTS.userActions.enableManagedPlan:
                this.changeManagedPlan([user], true);
                break;

            case this.dic.CONSTANTS.userActions.disableManagedPlan:
                this.changeManagedPlan([user], false);
                break;

			case this.dic.CONSTANTS.userActions.suppressionList:
				this.checkUserOnSuppressionList([user]);
				break;

            case this.dic.CONSTANTS.userActions.sendWelcomeEmail:
                this.sendWelcomeEmail([user]);
                break;
        }
    };

	openSetUserTimezonePopup = (users) => {
        this.setUserTimezonePopup = {
            users,
			currentTimezone: users.length > 1 ? null : this.timeZones.find(itm => itm.zone === users[0].timezone),
            newTimezone: '',
			setTimezoneInProcess: false,
            show: true,
			confirmCb: () => {
				if (!this.setUserTimezonePopup.newTimezone) {
					this.ns.showWarnMessage(util.format(this.dic.ERRORS.noSelected, 'time zone'));
					return;
				}

				this.setUserTimezonePopup.setTimezoneInProcess = true;
				const newTimeZone = this.setUserTimezonePopup.newTimezone.zone;

				users.forEach(user => {
					this.updateUserTimeZoneExecute(user, newTimeZone);
					this.setUserTimezonePopup = null;
				});
			}
        }
    };

	updateUserTimeZoneExecute = (user, newTimeZone) => {
		if (user.status === this.dic.CONSTANTS.userInPlanStatus.invitationSent) {
			this.ns.showWarnMessage(this.dic.ERRORS.cannotSetInvitedUserTimezone);
			return;
		}

		const actionInfo = {
			action: this.dic.CONSTANTS.planUsersActions.updateTimezone,
			timezone: newTimeZone,
			isAdmin: user.user_role === this.dic.CONSTANTS.userRole.admin,
			depth: user.depth,
			parent:user.parent
		};

		this.rs.doActionOnPlanUser(user.email, actionInfo).then((response) => {
			user.timezone = newTimeZone;

			// update local userInfo if timezone was changed for the current customer admin
			if (this.userInfo.id === user._id) {
				this.userInfo.timezone = newTimeZone;
			}

			this.ns.showInfoMessage(this.dic.MESSAGES.userDetailsAccount);

			if (this.changeUserSettingsPopup) {
				this.changeUserSettingsPopup.editTimezone = null;
			}
		}, (err) => {
			if (this.setUserTimezonePopup) {
				this.setUserTimezonePopup.setTimezoneInProcess = false;
			}
		});
	}

    openChangeUserNamePopup = (userObj) => {
		const tabs = {
			general: 'General',
			mfa: 'Login MFA',
			advSetting: 'Advanced Email Settings'
		};

        this.changeUserSettingsPopup = {
			tabs,
			activeTab: tabs.general,
            user: userObj,
			currentTimezone: this.timeZones.find(itm => itm.zone === userObj.timezone),
			mfa: {
				strict: userObj.preferences?.require_2fa?.strict || false,
				enabled: userObj.preferences?.require_2fa?.enabled || false,
			},
			advanced: userObj.preferences?.default_advanced || {secure: {}, general: {}, email_me: {}, postmark: {}},

            show: true
        };
    };

	updateUserAdvEmailSettings = (userObj) => {
		this.changeUserSettingsPopup.inProcess = true;

		const advanced = {};
		for (const [sectionKey, section] of Object.entries(this.changeUserSettingsPopup.advanced)) {
			advanced[sectionKey] = {};
			for (const [settingKey, setting] of Object.entries(section)) {
				advanced[sectionKey][settingKey] = setting.value;
			}
		}

		const actionInfo = {
			action: this.dic.CONSTANTS.planUsersActions.emailAdvSettings,
			advanced: advanced,
			isAdmin: userObj.user_role === this.dic.CONSTANTS.userRole.admin,
			depth: userObj.depth,
			parent: userObj.parent
		};
		this.rs.doActionOnPlanUser(userObj.email, actionInfo).then(() => {
			this.changeUserSettingsPopup.inProcess = false;
			this.ns.showInfoMessage(this.dic.MESSAGES.userDetailsAccount);
		}, (err) => {
			if (err.data && err.data.message) {
				this.ns.showErrorMessage(err.data.message);
			}
			this.changeUserSettingsPopup.inProcess = false;
		});
	}

    updateUserName = (userObj, firstName, lastName) => {
        // validation
        if (!firstName || !lastName) {
            this.ns.showErrorMessage(this.dic.ERRORS.profileNeededInfo)
            return;
        }

		this.changeUserSettingsPopup.inProcess = true;

        const actionInfo = {
            action: this.dic.CONSTANTS.planUsersActions.updateName,
            firstName: firstName,
            lastName: lastName,
            isAdmin: userObj.user_role === this.dic.CONSTANTS.userRole.admin,
            depth: userObj.depth,
            parent: userObj.parent
        };
        this.rs.doActionOnPlanUser(userObj.email, actionInfo).then(() => {
            userObj.name = `${firstName} ${lastName}`;
			this.changeUserSettingsPopup.inProcess = false;
			this.changeUserSettingsPopup.editName = null;
			this.ns.showInfoMessage(this.dic.MESSAGES.userDetailsAccount);
        }, (err) => {
            if (err.data && err.data.message) {
                this.ns.showErrorMessage(err.data.message);
            }
			this.changeUserSettingsPopup.inProcess = false;
		});
    }

	updateUserJobTitle = (userObj, jobTitle) => {
		// validation
		if (!jobTitle) {
			return;
		}

		this.changeUserSettingsPopup.inProcess = true;

		const actionInfo = {
			action: this.dic.CONSTANTS.planUsersActions.jobTitle,
			job_title: jobTitle,
			isAdmin: userObj.user_role === this.dic.CONSTANTS.userRole.admin,
			depth: userObj.depth,
			parent: userObj.parent
		};
		this.rs.doActionOnPlanUser(userObj.email, actionInfo).then(() => {
			userObj.job_title = jobTitle;
			this.changeUserSettingsPopup.inProcess = false;
			this.changeUserSettingsPopup.editJobTitle = null;
			this.ns.showInfoMessage(this.dic.MESSAGES.userDetailsAccount);
		}, (err) => {
			if (err.data && err.data.message) {
				this.ns.showErrorMessage(err.data.message);
			}
			this.changeUserSettingsPopup.inProcess = false;
		});
	}


	updateUserGlobalReviewerExecute = (type) => {
        const userObj = this.userPermissionPopup.userObj;
        const actionInfo: any = {
			type: type,
            action: this.dic.CONSTANTS.planUsersActions.globalReviewer,
            isAdmin: userObj.user_role === this.dic.CONSTANTS.userRole.admin,
            depth: userObj.depth,
            parent: userObj.parent,
			enabled: userObj.global_reviewer[type]?.enabled
		};

		if (actionInfo.enabled) {
			this.userPermissionPopup.userObj.show_multi_tenant = actionInfo.enabled;
			this.userPermissionPopup.show_multi_tenant = actionInfo.enabled;
		}

		switch (type) {
			case 'inbound':
				actionInfo.reviewer_allow_release_malicious = userObj.global_reviewer[type].reviewer_allow_release_malicious;
				actionInfo.allow_view_content = userObj.global_reviewer[type].allow_view_content;
				actionInfo.allow_change_configuration = userObj.global_reviewer[type].allow_change_configuration;
				break;

			case 'outbound':
				actionInfo.allow_view_content = userObj.global_reviewer[type].allow_view_content;
				actionInfo.allow_change_configuration = userObj.global_reviewer[type].allow_change_configuration;
				break;

			case 'archive':
				actionInfo.allow_view_content = userObj.global_reviewer[type].allow_view_content;
				break;

			case 'general':
				actionInfo.allow_review_access_main_plan = userObj.global_reviewer.allow_review_access_main_plan
				break;
		}

        this.rs.doActionOnPlanUser(userObj.email, actionInfo).then((response) => {
            this.setRolePriority(userObj, this.mainPlanAdmin);
            this.ns.showInfoMessage(this.dic.MESSAGES.planUserUpdated);
		}, err => {
		});
    };

    withoutTime = (date=null) => {
        let d;
        if (date) {
            d = new Date(date);
        }
        else {
            d = new Date();
        }
        d.setHours(0, 0, 0, 0);
        return d;
    };

	getUserStatusTooltip = (userObj) => {
		switch (userObj.status) {
			case this.dic.CONSTANTS.userInPlanStatus.active:
				userObj.statusToolip = 'The user is actively sending outbound emails through your Trustifi plan';
				break;

			case this.dic.CONSTANTS.userInPlanStatus.inactive:
				userObj.statusToolip = 'The user has not sent any emails through your Trustifi plan in the past 60 days';
				break;

			case this.dic.CONSTANTS.userInPlanStatus.blocked:
				userObj.statusToolip = 'The user has been blocked. They cannot sign into their Trustifi account or send emails through your plan';
				break;

			case this.dic.CONSTANTS.userInPlanStatus.blockUser24hours:
				userObj.statusToolip = 'The user has been blocked for 24 hours. They cannot sign into their Trustifi account or send emails through your plan';
				break;

			case this.dic.CONSTANTS.userInPlanStatus.riskyUser24hours:
				userObj.statusToolip = 'The user has been temporarily marked as "Risky". All emails sent by this user will undergo enhanced threat scans';
				break;

			case this.dic.CONSTANTS.userInPlanStatus.invitationSent:
				userObj.statusToolip = 'An invitation has been sent to add this user to your Trustifi plan, and they haven\'t completed the onboarding process yet';
				break;

			case this.dic.CONSTANTS.userInPlanStatus.expired:
				userObj.statusToolip = 'The plan\'s expiration date has passed and needs to be renewed. If the plan isn\'t renewed on time, it could be automatically blocked';
				break;

			case this.dic.CONSTANTS.userInPlanStatus.planBlocked:
				userObj.statusToolip = 'The user\'s plan has been blocked, all users under this plan cannot sign into their Trustifi account or send emails through this plan';
				break;
		}
	}

    formatDateString = (date) => {
        if (!date) {
            return;
        }

        const formatDate = new Date(date);
        let formatMonth: any = formatDate.getMonth() + 1;
        let formatDay: any = formatDate.getDate();
        const formatYear = formatDate.getFullYear();

        if (formatMonth < 10) {
            formatMonth = '0' + formatMonth;
        }
        if (formatDay < 10) {
            formatDay = '0' + formatDay;
        }
        return String(formatMonth + '/' + formatDay + '/' + formatYear);
    };

    setUserAsAdmin = () => {
        if (this.newPlanWizard?.inProcess) {
            return;
        }

        const curSharedUser = this.newPlanWizard.curSharedUser;
        const copyPolicyData = this.newPlanWizard.copyPolicyData;
        const currentAdminObj = this.newPlanWizard.currentAdminObj;

        if (!curSharedUser.adminExpirationDate) {
            curSharedUser.errMsg = this.dic.ERRORS.sharedPlanNoExpiration;
            return;
        }
        if (!curSharedUser.allowedUsers) {
            curSharedUser.errMsg = this.dic.ERRORS.sharedPlanNoUsers;
            return;
        }
        if (typeof curSharedUser.allowedLicenses !== 'number' || curSharedUser.allowedLicenses < 0) {
            curSharedUser.errMsg = this.dic.ERRORS.sharedPlanNoInboundLicenses;
            return;
        }
        if (curSharedUser.setAsPartner && !curSharedUser.customerId) {
            curSharedUser.errMsg = this.dic.ERRORS.sharedPlanNoPartnerId;
            return;
        }
        if (copyPolicyData.enabled && !copyPolicyData.selectedPolicyTemplate) {
            copyPolicyData.error = true;
            this.ns.showErrorMessage(util.format(this.dic.ERRORS.noSelected, 'policy'));
            return;
        }
        if (!curSharedUser.setAsPartner) {
            curSharedUser.customerId = '';
        }

        const expirationDate = this.getPlanExpirationDate(curSharedUser.adminExpirationDate, curSharedUser.extendExpirationMethod, curSharedUser.planSubType);
        const userDomain = this.gs.getDomain(curSharedUser.email);
        curSharedUser.errMsg = '';
        this.newPlanWizard.inProcess = true;

        const planData: any = {
            action: this.dic.CONSTANTS.planAdminActions.allocatePlan,
            depth: curSharedUser.depth,
            parent: curSharedUser.parent,
            plan: {
                hide_partner_access: curSharedUser.hide_partner_access,
                planSubType: curSharedUser.planSubType,
                users: curSharedUser.allowedUsers,
                inboundLicenses: curSharedUser.allowedLicenses,
                expired: expirationDate,
                customerId: curSharedUser.customerId,
                company_name: curSharedUser.companyName || curSharedUser.customerId || userDomain,
                archive: curSharedUser.archive,
                threat_simulation: curSharedUser.threat_simulation,
                allow_support_wa: curSharedUser.allow_support_wa,
                extendExpiration: curSharedUser.extendExpirationMethod
            }
        };

        if (copyPolicyData.enabled) {
            planData.policy = {
                name: copyPolicyData.selectedPolicyTemplate.name,
                fromAdmin: copyPolicyData.selectedFromAdmin.email
            };
        }

        this.rs.doActionOnPlanAdmin(curSharedUser.email, planData).then(res => {
            this.newPlanWizard = null;

            curSharedUser.alloc_plan_id = {
                _id: res.planId,
                shared_plan: {allowed_users: curSharedUser.allowedUsers},
                threat_protection: {allowed_users: curSharedUser.allowedLicenses},
                plan_sub_type: curSharedUser.planSubType,
                expired: expirationDate,
                customer_id: curSharedUser.customerId,
                company_name: curSharedUser.companyName || curSharedUser.customerId || userDomain,
                archive: curSharedUser.archive,
                threat_simulation: curSharedUser.threat_simulation,
            };

            const parentAdmin = curSharedUser.depth && curSharedUser.parent
                ? this.sharedPlanInfo.users.find(itm => itm.email === curSharedUser.parent)
                : this.mainPlanAdmin;

            parentAdmin.alloc_plan_id.shared_plan.used_users = parentAdmin.alloc_plan_id.shared_plan.used_users + curSharedUser.allowedUsers - 1;
            parentAdmin.alloc_plan_id.threat_protection.used_users = parentAdmin.alloc_plan_id.threat_protection.used_users + curSharedUser.allowedLicenses;
            curSharedUser.user_role = this.dic.CONSTANTS.userRole.admin;
            curSharedUser.customer_id = curSharedUser.customerId;
            curSharedUser.customer_admin = !!curSharedUser.customerId;
            curSharedUser.planUsers = [];
            this.setRolePriority(curSharedUser, parentAdmin);
            if (this.gs.planAdmins?.length && !curSharedUser.hide_partner_access) {
                this.gs.planAdmins.push({email: curSharedUser.email});
                this.gs.updatePlanAdminsSubj.next({planAdmins: this.gs.planAdmins, init: false});
            }
        }, err => {
            if (err?.data?.message) {
                this.ns.showErrorMessage(err.data.message);
            }
            this.newPlanWizard.inProcess = false;
        });
    };

	isTemplatePlan(userObj) {
		return userObj.isTemplate || userObj.alloc_plan_id?.plan_sub_type === 'template';
	}

    openMoveUserToAdminPopup = (userToMove) => {
        if (!this.sharedPlanInfo.users || this.sharedPlanInfo.users.length === 1) {
            this.ns.showWarnMessage(this.dic.ERRORS.noOtherAdmins);
            return;
        }

        const users = _.cloneDeep(this.sharedPlanInfo.users);
		users.forEach(user => user.hide = false);
        const oldAdmin = getCurrentAdminOfUser(userToMove._id, users);
        const adminsList = _.filter(users, user => {
			if (this.isTemplatePlan(user) || !user.alloc_plan_id) {
				return false;
			}
            if (user.user_role === this.dic.CONSTANTS.userRole.admin && (user.status === this.dic.CONSTANTS.userInPlanStatus.active || user.status === this.dic.CONSTANTS.userInPlanStatus.inactive) && user.email !== oldAdmin.email) {
                user.displayName = user.name + ' (' + (user.alloc_plan_id.is_managed ? user.email.split('@')[0] : user.email) + ')';
                return true;
            }
            else {
                return false;
            }
        });

        if (!adminsList.length) {
            this.ns.showWarnMessage(this.dic.ERRORS.noOtherAdmins);
            return;
        }

        this.moveUserToAdminPopup = {
            userToMove,
            adminsList,
            oldAdmin,
            selectedAdmin: null,
            show: true
        };
    };

    confirmMoveUserToAdmin = () => {
        if (this.moveUserToAdminInProcess) {
            return;
        }
		if (!this.moveUserToAdminPopup.selectedAdmin) {
			this.ns.showWarnMessage(util.format(this.dic.ERRORS.noSelected, 'admin'));
			return;
		}

        this.moveUserToAdminInProcess = true;

        // for shortening variables text:
        const userToMove = this.moveUserToAdminPopup.userToMove;
        const oldAdmin = this.moveUserToAdminPopup.oldAdmin;
        const newAdmin = this.moveUserToAdminPopup.selectedAdmin;

        const moveData = {
            action: this.dic.CONSTANTS.planAdminActions.moveToAdmin,
            fromAdminEmail: oldAdmin.email,
            toAdminEmail: newAdmin.email
        };

        this.rs.doActionOnPlanAdmin(userToMove.email, moveData).then(res => {
            //remove user
            if (oldAdmin.planUsers) {
                for (let idx = 0; idx < oldAdmin.planUsers.length; idx++) {
                    if (oldAdmin.planUsers[idx].email === userToMove.email) {
                        oldAdmin.planUsers.splice(idx, 1);
                        break;
                    }
                }
            }
            else {
                for (let idx = 0; idx < this.sharedPlanInfo.users.length; idx++) {
                    if (this.sharedPlanInfo.users[idx].email === userToMove.email) {
                        this.sharedPlanInfo.users.splice(idx, 1);
                        break;
                    }
                }
            }

            userToMove.company_name_display = newAdmin.company_name_display || '';
            // add user
            if (newAdmin.planUsers) {
                newAdmin.planUsers.push(userToMove);
            }
            else {
                this.sharedPlanInfo.users.push(userToMove);
            }

            // in case the old admin was open to show it's users and now he dosent have any users - close it
            if (oldAdmin.planUsers && !oldAdmin.planUsers.length && oldAdmin.planShowUsers) {
                this.togglePlanUsers(oldAdmin, false);
            }

            this.updateListView(this.usersListView);

            this.moveUserToAdminPopup = null;
            this.moveUserToAdminInProcess = false;
        }, err => {
            if (err && err.data && err.data.message && !err.data.display_bar) {
                this.ns.showErrorMessage(err.data.message);
            }
            this.moveUserToAdminInProcess = false;
        });
    };

    removeUser =(usersToRemove) => {
        if (!usersToRemove || !usersToRemove.length) {
            return;
        }
        usersToRemove.forEach(userToRemove => {
            let user = _.find<any>(this.users, userToRemove);
            if (user) {
                user.checked = false;
				user.selected = false;
                _.remove<any>(this.users, user)

                let tag:any = document.getElementById(`user-tag-${user.email}`);
                if (tag) {
                    tag.remove();
                }
            }
        });
    };

	confirmNewUserEmail = (newUserEmail) => {
		if (!newUserEmail) {
			return;
		}

		if (!this.validateEmail(newUserEmail)) {
			// this.ns.showWarnMessage(util.format(this.dic.ERRORS.EnterValidX, 'email address'));
			return;
		}

		this.users.push({_id: -1, name: newUserEmail, email: newUserEmail});

		this.addNewUserInputTxt = '';
		document.getElementById('adminContacts').focus();
	}

	confirmNewUserFromContacts = (contact) => {
		if (!_.find<any>(this.users, {_id: contact._id, name: contact.name, email: contact.email})) {
			this.users.push({_id: contact._id, name: contact.name, email: contact.email});
		}

		this.addNewUserInputTxt = '';
		this.focusNewUserInput();
	}

	confirmAddNewUserFromMyContacts = (contactOrList) => {
		if (contactOrList.length && contactOrList.contacts && contactOrList.contacts.length) {
			this.users.push({_id: contactOrList._id, name: contactOrList.name, email: 'List', originalList: contactOrList});
		}
		else {
			contactOrList.forEach(contactObj => {
				// validate that user does not already exist in list before adding
				if (!_.find<any>(this.users, {email: contactObj.email})) {
					this.users.push({_id: contactObj._id, name: contactObj.name, email: contactObj.email});
				}
			});
		}
	}

	removeNewUser = (userIndex) => {
		this.users.splice(userIndex, 1);
	}

	focusNewUserInput = () => {
		document.getElementById('adminContacts').focus();
	}

    validateEmail = (email) => {
        if (!email || email === '') return false;
        return this.gs.validateEmail(email);
    };

    exportUsersCsv = (sortBy) => {
        if (!this.sharedPlanInfo.users || !this.sharedPlanInfo.users.length) {
            this.ns.showWarnMessage(this.dic.ERRORS.noDataToExportCsv);
            return;
        }

        let csvString = "Name,Email,Job Role,Status,Role,Company Name,Email Relay,Reviewer\n";

		let sortedTable = _.filter(this.sharedPlanInfo.users,user => {return !user.hide});
		if (sortBy) {
			sortedTable = this.gs.sortTable(sortedTable, sortBy);
		}

        // flatten the users list from in-depth users
        sortedTable = this.flattenUsersList(sortedTable);

        sortedTable.forEach(user => {
			if (!user.hide) {
				csvString += `"${user.name}",${user.email},"${user.job_title || 'N/A'}",${user.status},${this.gs.toCapitalize(user.user_role_display)},${user.company_name_display},${user.is_relay || false},"${user.user_reviewer || ''}"\n`;
			}
        });

        this.gs.exportCsv(csvString, `outbound_mailboxes.csv`);
    };

    flattenUsersList =(list) => {
        let flatList = [];
        list.forEach(user => {
            if (!user.planUsers || !user.planUsers.length) {
                flatList.push(user);
            }
            else {
                flatList.push(user);
                flatList = flatList.concat(this.flattenUsersList(user.planUsers));
            }
        });
        return flatList;
    }

    getAllContacts = () => {
        if (this.allContacts) {
            return;
        }

        this.rs.getAllContacts().then((response) => {
            this.allContacts = response;
        });
    };

    openAddressBookModal = () => {
        this.listAdded = false;
        this.modalData = {
            openContactsAddressBook: true
        };
    };

	initFilters = () => {
		this.filterData = {
			filterType: this.dic.CONSTANTS.tableFilters.userManagement,
			filters: {
				status: Object.values(this.dic.CONSTANTS.userInPlanStatus),
				role: this.rolesExisting,
				reviewer: ['Outbound', 'Inbound', 'Archive', 'Account Takeover', 'Threat Simulation', 'Partner'],
				'email relay': [true, false],
				'executives': [true, false]
			},
			tableFilterTemplatesRefName: this.dic.CONSTANTS.tableFilterTemplatesRefNames.user_mgmt,
			initFiltersFunction: this.initFilters
		};
		if (this.isPartnerAdmin && this.companyNamesExisting.length) {
			this.filterData.filters['company name'] = this.companyNamesExisting;
			this.filterData.filters['plan type'] = ['Annual', 'Monthly', 'POC'];
		}
	}

	setPartnersPageFilter = () => {
		// set filter on partners when under partners page
		if (this.router.url.includes(this.dic.CONSTANTS.appStates.partner)) {
			const updateFilterData = [
				{
					key: 'role',
					option: 'Plan Admin',
					newValue: true
				},
				{
					key: 'role',
					option: 'Managed Plan',
					newValue: true
				},
			];

			setTimeout(() => {
				this.usersTableEl.updateFilterOptions(updateFilterData);
			});
		}
	}

	checkUserOnSuppressionList = (selectedUsers) => {
		if (!selectedUsers?.length) {
			return;
		}

		eachLimit(selectedUsers, 5, (userObj, asyncCb) => {
			const actionInfo = {
				action: this.dic.CONSTANTS.planUsersActions.suppressionList,
				isAdmin: userObj.user_role === this.dic.CONSTANTS.userRole.admin,
				depth: userObj.depth,
				parent: userObj.parent
			};
			this.rs.doActionOnPlanUser(userObj.email, actionInfo).then((isSuppressionList) => {
				if (isSuppressionList?.exists) {
					this.ns.showWarnMessage(`${userObj.email} exists on suppression list`);
				}
				else {
					this.ns.showInfoMessage(`${userObj.email} does not exist on suppression list`);
				}
				setTimeout(() => {
					asyncCb();
				}, 300);
				}, (err) => {
				asyncCb();
			});
		});
	}

    toggleMFAForPlanUsers = (selectedUsers) => {
        if (!selectedUsers?.length) {
            return;
        }

		const enabled = selectedUsers.length === 1 ? selectedUsers[0].preferences?.require_2fa?.enabled || false : false;
		const strict = selectedUsers.length === 1 ? selectedUsers[0].preferences?.require_2fa?.strict || false : false;
		this.userMfaPopup = {
			show: true,
			enabled,
			strict,

			doneCb: (type) => {
				switch (type) {
					case 'enabled':
					case 'strict':
						selectedUsers.forEach((userObj) => {
							this.toggleMFAForPlanUsersExecute(userObj, type, this.userMfaPopup[type]);
						});
						break;
				}
			}
		};
    };

	toggleMFAForPlanUsersExecute = (userObj, type, value) => {

		switch (type) {
			case 'enabled':
			case 'strict':
				const actionInfo = {
					action: this.dic.CONSTANTS.planUsersActions.mfa,
					type,
					enabled: value,
					isAdmin: userObj.user_role === this.dic.CONSTANTS.userRole.admin,
					depth: userObj.depth,
					parent: userObj.parent
				};
				this.rs.doActionOnPlanUser(userObj.email, actionInfo).then(() => {
					if (type === 'enabled') {
						userObj.preferences.require_2fa.enabled = value;
					}
					else {
						userObj.preferences.require_2fa.strict = value;
						if (userObj.preferences.require_2fa.strict) {
							userObj.preferences.require_2fa.enabled = true;
						}
					}

					this.ns.showInfoMessage(this.dic.MESSAGES.planUsersUpdated);
				}, (err) => {
				});
				break;
		}
	}

    changeManagedPlan = (selectedUsers, isManaged) => {
        let admins = _.filter(selectedUsers, u => u.user_role === this.dic.CONSTANTS.userRole.admin && u._id !== this.mainPlanAdmin._id && (u.status === this.dic.CONSTANTS.userInPlanStatus.active || u.status === this.dic.CONSTANTS.userInPlanStatus.inactive));
        if (!admins || !admins.length) {
            this.ns.showWarnMessage(this.dic.ERRORS.actionOnlyForAdmins);
            return;
        }

        let title, subTitle, body
        if (isManaged) {
            title = this.dic.CONSTANTS.userActions.enableManagedPlan;
            subTitle = 'You are about to change this plan to a "managed plan"';
            body = ['The plan will be managed directly by you and the previous plan admin will not receive any notifications for the plan'];
        }
        else {
            title = this.dic.CONSTANTS.userActions.disableManagedPlan;
            subTitle = 'You are about to change this plan to a regular plan';
            body = ['The previously assigned plan admin will manage the plan and will receive all notifications for the plan'];
        }

        this.gs.showPopup({
            title: title,
            subTitle: subTitle,
            body: body,
            type: this.dic.CONSTANTS.popupWarning,
            doneBtnText: 'Apply',
            doneCb: () => {
                admins.forEach((userObj) => {
                    this.rs.doActionOnPlanAdmin(userObj.email, {
                        action: this.dic.CONSTANTS.planAdminActions.setManaged,
                        depth: userObj.depth,
                        parent: userObj.parent,
                        enabled: isManaged
                    }).then(() => {
                        userObj.alloc_plan_id.is_managed = isManaged;
						this.setEmailAndRoleDisplay(userObj, this.mainPlanAdmin)
                    });
                });

                this.ns.showInfoMessage(this.dic.MESSAGES.planUsersUpdated);
            }
        });
    };

    changeUsersStatus = (selectedUsers, isBlocked) => {
        if (!selectedUsers || !selectedUsers.length) {
            return;
        }

        const title = isBlocked ? this.dic.CONSTANTS.userActions.blockUsers: this.dic.CONSTANTS.userActions.unblockUsers;
        const connector = isBlocked ? 'not ': '';
        let subTitle;

        subTitle = `${title} - users will ${connector}be able to access their account`;

        this.gs.showPopup({
            title: title,
            subTitle: subTitle,
            body: [],
            type: this.dic.CONSTANTS.popupWarning,
            doneBtnText: title,
            doneCb: () => {
                selectedUsers.forEach((userObj) => {
                    const actionInfo = {
                        action: this.dic.CONSTANTS.planUsersActions.status,
                        block: isBlocked,
                        depth: userObj.depth,
                        parent: userObj.parent
                    };
                    this.rs.doActionOnPlanUser(userObj.email, actionInfo).then(() => {
                        userObj.status = isBlocked ? userObj.user_role === this.dic.CONSTANTS.userRole.admin ? this.dic.CONSTANTS.userInPlanStatus.planBlocked
                            : this.dic.CONSTANTS.userInPlanStatus.blocked : this.dic.CONSTANTS.userInPlanStatus.active;

						this.getUserStatusTooltip(userObj);
                    }, (err) => {
                    });
                });

                this.ns.showInfoMessage(this.dic.MESSAGES.planUsersUpdated);            }
        });
    };

    sendWelcomeEmail = (selectedUsers) => {
        if (!selectedUsers || !selectedUsers.length) {
            return;
        }

        this.gs.showPopup({
            title: 'Send Welcome Email',
            subTitle: `You are about to send a welcome email to ${selectedUsers.length} users`,
            body: ['Recipients will be able to reset their account password by clicking on "Create New Password"'],
            type: this.dic.CONSTANTS.popupInfo,
            doneBtnText: 'Send',
            doneCb: () => {
                selectedUsers.forEach((userObj) => {
                    const actionInfo = {
                        action: this.dic.CONSTANTS.planUsersActions.welcomeEmail,
                        isAdmin: userObj.user_role === this.dic.CONSTANTS.userRole.admin,
                        depth: userObj.depth,
                        parent: userObj.parent
                    };
                    this.rs.doActionOnPlanUser(userObj.email, actionInfo).then(() => {
                        this.ns.showInfoMessage(this.dic.MESSAGES.planUserWelcomeSent);
                    }, (err) => {
                    });
                });
            }
        });
    };

    updateListView = (listView) => {
        this.usersListView = listView;
        switch (listView) {
            case this.dic.CONSTANTS.userMgmntListViews.all:
                this.usersList = this.sharedPlanInfo.users;
                break;

            case this.dic.CONSTANTS.userMgmntListViews.domains:
                this.usersList = this.createPerDomainList();
                break;

            case this.dic.CONSTANTS.userMgmntListViews.company:
                this.usersList = this.createCompanyGroups();
                break;
        }
        this.loadingUsersInProcess = false;
    };

	createPerDomainList = () => {
		const domainsList = [];
		const domainGroups = _.groupBy(this.sharedPlanInfo.users, user => {
			const emailParts = user.email.split('@');
			const userDomain = user.alloc_plan_id?.is_managed ? emailParts[0] : emailParts[1];
			return userDomain;
		});

		_.each(domainGroups, (domainUsers, domainName) => {
			domainsList.push({
				domainName,
				isCompanyTitleRecord: true,
				isSelectable: false,
				hideActions: true,
				planUsers: domainUsers
			});
		});

		return domainsList;
	};

	// CC: taken from inbound-mailboxes.component.ts -> getMailboxesAliases
	getMailboxesAliases = (show) => {
		this.showAliases = show;
	};

	openSuppressionPopup = () => {
		const filteredUsers = this.sharedPlanInfo.users
			.filter(user => !user.planUsers && user.status !== this.dic.CONSTANTS.userInPlanStatus.invitationSent)
			.map(user => ({ ...user })); // clone each user (shallow)

		this.suppressionPopup = {
			show: true,
			users: filteredUsers,
			// CC: progress indication - suppression is checked 1-by-1 due to rate limit
			inProcess: true,
			checkedCount: 0,
			totalCount: filteredUsers.length,
			progressPercent: 0,

			search: (searchTerm) => {
				this.suppressionPopup.users.forEach(record => {
					// search
					if (searchTerm) {
						searchTerm = searchTerm.toLowerCase();
						const isFound = record.email.includes(searchTerm);
						if (!isFound) {
							record.hide = true;
							return;
						}
					}

					// filter
					// // no filters for this table

					record.hide = false;
				});
			}
		};

		eachLimit(this.suppressionPopup.users, 1, (userObj, asyncCb) => {
			// CC: popup was closed - abort remaining checks so they don't run in the background
			if (!this.suppressionPopup) {
				return asyncCb(true);
			}
			const actionInfo = {
				action: this.dic.CONSTANTS.planUsersActions.suppressionList,
				isAdmin: userObj.user_role === this.dic.CONSTANTS.userRole.admin,
				depth: userObj.depth,
				parent: userObj.parent
			};
			this.rs.doActionOnPlanUser(userObj.email, actionInfo).then((isSuppressionList) => {
				userObj.is_suppressed = isSuppressionList?.exists;
				this.updateSuppressionProgress(); // CC: advance progress bar

				setTimeout(() => {
					asyncCb();
				}, 800);
			}, (err) => {
				this.updateSuppressionProgress(); // CC: advance progress bar
				asyncCb();
			});
		}, () => {
			// CC: all users checked - hide progress bar
			if (this.suppressionPopup) {
				this.suppressionPopup.inProcess = false;
			}
		});
	}

	// CC: update suppression check progress (checked count + percent)
	updateSuppressionProgress = () => {
		if (!this.suppressionPopup) {
			return;
		}
		this.suppressionPopup.checkedCount++;
		this.suppressionPopup.progressPercent = this.suppressionPopup.totalCount ? Math.round((this.suppressionPopup.checkedCount / this.suppressionPopup.totalCount) * 100) : 100;
	}

    openAccountConfigPopup = () => {
		const tabs = {
			login: 'Login Options',
			general: 'General',
		};

		this.accountConfigPopup = {
			activeTab: tabs.login,
			tabs: tabs,

			allowedLoginMethods: [{display: 'SSO', value: 'sso'}, {display: 'SAML/OIDC', value: 'openid'}, {display: 'Email + Password', value: 'password'}],
			enforceLoginMethod: !!this.sharedPlanInfo.policy.allow_login_methods.value.length,
			enforcePasswordExpiration: _.cloneDeep(this.accountPasswordExpiration),
			loginCountriesMethod: this.sharedPlanInfo.login_countries.type,
			countries: {
				allowOnly: this.initCountries(),
				blockOnly: this.initCountries()
			},
			mfa: {
				enforce: this.sharedPlanInfo.policy?.enforce_mfa_for_new_users?.value || false,
				skip_mfa_for_sso: this.sharedPlanInfo.policy?.enforce_mfa_for_new_users?.skip_mfa_for_sso || false,
			},
			show: false,
			applyInProcess: false,
		}

		this.accountConfigPopup.allowedLoginMethods.forEach((method) => {
			method.selected = this.sharedPlanInfo.policy.allow_login_methods.value.includes(method.value);
        });

		this.accountConfigPopup.countries.allowOnly.forEach(country => {
			country.selected = this.sharedPlanInfo.login_countries.allowlist.includes(_.upperCase(country.iso2));
		});
		this.accountConfigPopup.countries.blockOnly.forEach(country => {
			country.selected = this.sharedPlanInfo.login_countries.blocklist.includes(_.upperCase(country.iso2));
		});

		this.accountConfigPopup.show = true;
    }

	initCountries = () => {
		const countries = _.cloneDeep($.fn['intlTelInput'].getCountryData());
		countries.forEach(countryObj => {
			countryObj.icon = 'flag-icon flag-' + countryObj.iso2;
		});

		return countries;
	}

	updateGeneralSettings = (key) => {
		const actionInfo = {
			action: this.dic.CONSTANTS.planOutboundAction.generalSettings,
			key,
			enabled: this.sharedPlanInfo[key]
		};
		this.rs.doActionOnOutboundPlan(actionInfo).then(() => {
		}, (err) => {
			if (err && err.data && err.data.message && !err.data.display_bar) {
				this.ns.showErrorMessage(err.data.message);
			}
		});
	};


	updateAllowedLoginMethods = () => {
		if (this.accountConfigPopup.enforceLoginMethod && !_.some(this.accountConfigPopup.allowedLoginMethods, 'selected')) {
			this.ns.showWarnMessage(util.format(this.dic.ERRORS.xAtLeastOneX, 'select', 'login method'));
			return;
		}

		// check if values were changed before calling API:
		const isAllowedLoginMethodChanged = this.accountConfigPopup.enforceLoginMethod !== !!this.sharedPlanInfo.policy.allow_login_methods.value.length ||
			_.xor(_.map(_.filter(this.accountConfigPopup.allowedLoginMethods, 'selected'), 'value'), this.sharedPlanInfo.policy.allow_login_methods.value).length;
		if (!isAllowedLoginMethodChanged) {
			return;
		}

		let methods = [];
		if (this.accountConfigPopup.enforceLoginMethod) {
			methods = _.map(_.filter(this.accountConfigPopup.allowedLoginMethods,'selected'), 'value');
		}

		this.accountConfigPopup.applyInProcess = true;

		this.rs.doActionOnOutboundPlan({
			action: this.dic.CONSTANTS.planOutboundAction.loginMethods,
			methods: methods
		}).then(() => {
			this.sharedPlanInfo.policy.allow_login_methods.value = methods;
			this.accountConfigPopup.applyInProcess = false;
		}, (err) => {
			if (err && err.data && err.data.message && !err.data.display_bar) {
				this.ns.showErrorMessage(err.data.message);
			}
			this.accountConfigPopup.applyInProcess = false;
		});
    };

	updateLoginMFA = () => {
		this.accountConfigPopup.applyInProcess = true;

		this.rs.doActionOnOutboundPlan({
			action: this.dic.CONSTANTS.planOutboundAction.loginMFA,
			enforce: this.accountConfigPopup.mfa.enforce,
			skip_mfa_for_sso: this.accountConfigPopup.mfa.skip_mfa_for_sso,
		}).then(() => {
			this.accountConfigPopup.applyInProcess = false;
			this.sharedPlanInfo.policy.enforce_mfa_for_new_users.value = this.accountConfigPopup.mfa.enforce;
			this.sharedPlanInfo.policy.enforce_mfa_for_new_users.skip_mfa_for_sso = this.accountConfigPopup.mfa.skip_mfa_for_sso;
		}, (err) => {
			if (err && err.data && err.data.message && !err.data.display_bar) {
				this.ns.showErrorMessage(err.data.message);
			}
			this.accountConfigPopup.applyInProcess = false;
		});
	}

	updateLoginCountries = () => {
		if (this.accountConfigPopup.loginCountriesMethod === this.loginCountriesMethods.allowlist && !_.some(this.accountConfigPopup.countries.allowOnly, 'selected') ||
			this.accountConfigPopup.loginCountriesMethod === this.loginCountriesMethods.blocklist && !_.some(this.accountConfigPopup.countries.blockOnly, 'selected')) {
			this.ns.showWarnMessage(util.format(this.dic.ERRORS.xAtLeastOneX, 'select', 'country'));
			return;
		}

		// check if values were changed before calling API:
		const allowedCountriesCodes = _.map(_.filter(this.accountConfigPopup.countries.allowOnly, 'selected'), country => _.upperCase(country.iso2));
		const blockedCountriesCodes = _.map(_.filter(this.accountConfigPopup.countries.blockOnly, 'selected'), country => _.upperCase(country.iso2));

		const isLoginCountriesChanged = this.accountConfigPopup.loginCountriesMethod !== this.sharedPlanInfo.login_countries.type ||
			this.accountConfigPopup.loginCountriesMethod === this.loginCountriesMethods.allowlist &&  _.xor(allowedCountriesCodes, this.sharedPlanInfo.login_countries.allowlist).length ||
			this.accountConfigPopup.loginCountriesMethod === this.loginCountriesMethods.blocklist &&  _.xor(blockedCountriesCodes, this.sharedPlanInfo.login_countries.blocklist).length;
		if (!isLoginCountriesChanged) {
			return;
		}

		this.accountConfigPopup.applyInProcess = true;
		const data = {
			action: this.dic.CONSTANTS.planOutboundAction.loginCountries,
			type: this.accountConfigPopup.loginCountriesMethod,
			allowlist : allowedCountriesCodes,
			blocklist : blockedCountriesCodes
		};
		this.rs.doActionOnOutboundPlan(data).then(() => {
			this.sharedPlanInfo.login_countries.type = this.accountConfigPopup.loginCountriesMethod;
			this.sharedPlanInfo.login_countries.allowlist = data.allowlist || this.sharedPlanInfo.login_countries.allowlist;
			this.sharedPlanInfo.login_countries.blocklist = data.blocklist || this.sharedPlanInfo.login_countries.blocklist;
			this.accountConfigPopup.applyInProcess = false;
		}, (err) => {
			if (err && err.data && err.data.message && !err.data.display_bar) {
				this.ns.showErrorMessage(err.data.message);
			}
			this.accountConfigPopup.applyInProcess = false;
		});
	};

    updateAccountExpiration = () => {
		// check if values were changed before calling API:
		const isPasswordExpChanged = this.accountConfigPopup.enforcePasswordExpiration.enabled !== this.accountPasswordExpiration.enabled ||
			(this.accountConfigPopup.enforcePasswordExpiration.enabled && this.accountConfigPopup.enforcePasswordExpiration.expiration_days !== this.accountPasswordExpiration.expiration_days);
		if (!isPasswordExpChanged) {
			return;
		}

		const isEnabled = this.accountConfigPopup.enforcePasswordExpiration.enabled;
		if (isEnabled && !this.accountConfigPopup.enforcePasswordExpiration.expiration_days && this.accountConfigPopup.enforcePasswordExpiration.expiration_days !== 0) {
			this.ns.showWarnMessage(util.format(this.dic.ERRORS.cannotBeEmpty, 'Expiration days field'));
			return;
		}

		if (isEnabled && this.accountConfigPopup.enforcePasswordExpiration.expiration_days < 10) {
			this.ns.showWarnMessage(this.dic.ERRORS.minAccountPasswordExpiration);
			return;
		}

		if (isEnabled && this.accountConfigPopup.enforcePasswordExpiration.expiration_days > 365) {
			this.ns.showWarnMessage(this.dic.ERRORS.maxAccountPasswordExpiration);
			this.accountConfigPopup.enforcePasswordExpiration.expiration_days = 365;
			this.selectExpirationTextFlag = true;
			return;
		}

		this.accountConfigPopup.applyInProcess = true;
		this.rs.doActionOnOutboundPlan({
			action: this.dic.CONSTANTS.planOutboundAction.passwordExpiration,
			settings: {
				enabled: isEnabled,
				expiration_days: this.accountConfigPopup.enforcePasswordExpiration.expiration_days
			}
		}).then(() => {
			if (!isEnabled) {
				// don't save the user's input for expiration days in the UI if it was not enabled (so it doesn't count anyway...). so reset it.
				this.accountConfigPopup.enforcePasswordExpiration.expiration_days = this.accountPasswordExpiration.expiration_days;
			}
			this.accountPasswordExpiration = _.cloneDeep(this.accountConfigPopup.enforcePasswordExpiration);
			this.accountConfigPopup.applyInProcess = false;
		}, err => {
			if (err && err.data && err.data.message && !err.data.display_bar) {
				this.ns.showErrorMessage(err.data.message);
			}
			this.accountConfigPopup.applyInProcess = false;
		});
    };

    getPlanExpirationDate(planExpirationDate, extendExpirationMethod, planSubType?) {
        let expirationDate = new Date(planExpirationDate).toISOString();
        const resolvedSubType = planSubType ?? this.curSharedUser?.planSubType;
        if (extendExpirationMethod && resolvedSubType === this.dic.CONSTANTS.planSubType.annual) {
            const myDate = new Date(planExpirationDate);

            switch (extendExpirationMethod) {
                case this.expandMethods.threeYears.value:
                    expirationDate = new Date(myDate.setDate(myDate.getDate() + 365 * 3)).toISOString();
                    break;

                case this.expandMethods.twoYears.value:
                    expirationDate = new Date(myDate.setDate(myDate.getDate() + 365 * 2)).toISOString();
                    break;

                case this.expandMethods.oneYear.value:
                    expirationDate = new Date(myDate.setDate(myDate.getDate() + 365)).toISOString();
                    break;

                case this.expandMethods.oneMonth.value:
                    expirationDate = new Date(myDate.setMonth(myDate.getMonth() + 1)).toISOString();
                    break;
            }
        }

        return expirationDate;
    }

	searchFilterExecute = (user, filters) => {
		// need to match all filter types
		let numFilterToMatch = Object.keys(filters).length;

		if (filters.status && filters.status.length) {
			const isExpired = user.alloc_plan_id && user.alloc_plan_id.expired && this.withoutTime(user.alloc_plan_id.expired) < this.withoutTime();
			if ((filters.status.includes(user.status) && !isExpired) ||
				(filters.status.includes('Expired') && isExpired)) {
				numFilterToMatch--;
			}
		}
		if (filters['executives'] && filters['executives'].length) {
			if (filters['executives'].includes(user.is_executive)) {
				numFilterToMatch--;
			}
		}
		if (filters.role?.length) {
			if (filters.role.includes(user.user_role) ||
				filters.role.includes(user.user_role_display) ||
				filters.role.includes(user.alloc_plan_id?.customer_id)) {
				numFilterToMatch--;
			}
			else {
				if (filters.role.includes('Global Reviewer') && (user.global_reviewer?.inbound?.enabled || user.global_reviewer?.outbound?.enabled
					|| user.global_reviewer?.archive?.enabled || user.global_reviewer?.threat_simulation?.enabled || user.global_reviewer?.account_compromised?.enabled)) {
					numFilterToMatch--;
				}
			}
		}
		if (filters['email relay'] && filters['email relay'].length) {
			if (filters['email relay'].includes(user.is_relay)) {
				numFilterToMatch--;
			}
		}
		if (filters.reviewer?.length && this.sharedPlanInfo.reviewers) {
			if (filters.reviewer.includes('Outbound') && this.sharedPlanInfo.reviewers.outbound.find(itm => itm.email === user.email)) {
				numFilterToMatch--;
			}
			else if (filters.reviewer.includes('Inbound') && this.sharedPlanInfo.reviewers.inbound.find(itm => itm.email === user.email)) {
				numFilterToMatch--;
			}
			else if (filters.reviewer.includes('Archive') && this.sharedPlanInfo.reviewers.archive.find(itm => itm.email === user.email)) {
				numFilterToMatch--;
			}
			else if (filters.reviewer.includes('Account Takeover') && this.sharedPlanInfo.reviewers.account_compromised.find(itm => itm.email === user.email)) {
				numFilterToMatch--;
			}
			else if (filters.reviewer.includes('Threat Simulation') && this.sharedPlanInfo.reviewers.threat_simulation?.find(itm => itm.email === user.email)) {
				numFilterToMatch--;
			}
			else if (filters.reviewer.includes('Partner') && this.sharedPlanInfo.reviewers.partners?.find(itm => itm.email === user.email)) {
				numFilterToMatch--;
			}
		}

		if (filters['company name'] && filters['company name'].length) {
			if (filters['company name'].includes(user.company_name_display)) {
				numFilterToMatch--;
			}
		}

		if (filters['plan type'] && filters['plan type'].length && user.alloc_plan_id?.plan_sub_type) {
			const lowercasedArray = filters['plan type'].map(string => string.toLowerCase());
			if (lowercasedArray.includes(user.alloc_plan_id?.plan_sub_type)) {
				numFilterToMatch--;
			}
		}

		return !numFilterToMatch;
	}

	searchUserExecute = (user, searchTerm, activeFilters) => {
		if (searchTextExecute(user, searchTerm)) {
			if (!activeFilters || this.searchFilterExecute(user, activeFilters)) {
				showAllSubUsers(user);
				if (!this.doNotChangeIsExpandedStates) {
					user.isExpanded = false;
				}

				return true;
			}
		}

		let isFound = false;
		if (user.planUsers?.length) {
			for (let i = 0; i < user.planUsers.length; i++) {
				const isSubUserFound = this.searchUserExecute(user.planUsers[i], searchTerm, activeFilters);
				user.planUsers[i].hide = !isSubUserFound;
				if (isSubUserFound) {
					isFound = true;
					if (!this.doNotChangeIsExpandedStates) {
						user.isExpanded = searchTerm || activeFilters;
					}
				}
			}
		}

		return isFound;
	}
}



// when parent record is found by search and/or filter, remove hide flag from it's children recursively
function showAllSubUsers(user) {
	if (user.planUsers?.length) {
		user.planUsers.forEach(subUser => {
			subUser.hide = false;
			showAllSubUsers(subUser);
		});
	}
}

function searchTextExecute(user, searchTerm) {
	searchTerm = searchTerm.toLowerCase();
    return ((user.name && user.name.toLowerCase().indexOf(searchTerm) > -1) ||
		(user.companyName && user.companyName.toLowerCase().indexOf(searchTerm) > -1) ||
		(user.job_title?.toLowerCase().indexOf(searchTerm) > -1) ||
		(user.email && user.email.toLowerCase().indexOf(searchTerm) > -1) ||
        (user.company_name_display && ((user.company_name_display.toLowerCase().indexOf(searchTerm) > -1))));
}

function getCurrentAdminOfUser(userToSearchId, users) {
    let user;
    for (let i = 0; i < users.length; i++) {
        user = users[i];
        if (user._id === userToSearchId) {
            return users[0];
        }
        if (user.planUsers && user.planUsers.length) {
            let innerUser;
            for (let j = 0; j < user.planUsers.length; j++) {
                innerUser = user.planUsers[j];
                if (innerUser._id === userToSearchId) {
                    return user;
                }
            }
        }
    }
    return users[0];
}

